// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Data Grid Component - Filter */
.ids-data-grid {
  --ids-button-formatter-color-text-default: var(
    --ids-data-grid-filter-icon-color
  );
  --ids-button-formatter-color-background-hover: var(
    --ids-data-grid-filter-icon-color-background-hover
  );
  --ids-button-formatter-color-text-hover: var(
    --ids-data-grid-filter-icon-color-hover
  );
  --ids-menu-item-width-min: 190px;
  --ids-trigger-field-button-inset-inline-start: 0;
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper ids-dropdown {
  --ids-trigger-field-button-inset-inline-start: -1px;
  padding-top: 3px;
}
.ids-data-grid[data-row-height=md] ids-dropdown, .ids-data-grid[data-row-height=sm] ids-dropdown, .ids-data-grid[data-row-height=xs] ids-dropdown, .ids-data-grid[data-row-height=xxs] ids-dropdown {
  padding-top: 0;
}
.ids-data-grid ::slotted([slot^=filter-]) {
  align-items: center;
  display: flex;
  position: relative;
}
.ids-data-grid .ids-data-grid-header-cell-content.vertical-align-center {
  position: relative;
  top: calc(50% - var(--ids-space-sm));
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper {
  align-items: center;
  display: flex;
  position: relative;
  padding-inline: calc(var(--ids-space-xs) + 4px);
  padding-block-end: var(--ids-space-xs);
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper.hidden {
  display: none;
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper[hidden] {
  display: none;
}
.ids-data-grid .ids-data-grid-header-cell-filter-wrapper ids-dropdown[compact] ids-list-box-option {
  font-size: unset;
  min-height: var(--ids-size-20);
}
.ids-data-grid .ids-data-grid-header:not(.has-filter) .ids-data-grid-header-cell-filter-wrapper {
  display: none;
}
.ids-data-grid .ids-data-grid-header-cell.is-uppercase .ids-data-grid-header-cell-filter-wrapper ids-list-box-option,
.ids-data-grid .ids-data-grid-header-cell.is-uppercase .ids-data-grid-header-cell-filter-wrapper ids-dropdown::part(triggerfield-input),
.ids-data-grid .ids-data-grid-header-cell.is-uppercase .ids-data-grid-header-cell-filter-wrapper ids-input::part(input) {
  text-transform: uppercase;
}
.ids-data-grid [data-filter-conditions-button] {
  --ids-button-icon-compact-height: 20px;
  --ids-button-icon-compact-width: 36px;
  margin-inline-end: 2px;
  margin-inline-start: 0;
}
.ids-data-grid [data-filter-conditions-button] ids-icon {
  margin-inline-start: 3px;
  margin-inline-end: -3px;
}
.ids-data-grid [data-filter-conditions-button] ids-icon-button {
  padding-inline-start: 0;
}

/* Ids Data Grid Component - Header */
.ids-data-grid-header {
  position: sticky;
  display: grid;
  grid-template-columns: var(--ids-data-grid-column-widths);
  top: var(--ids-space-none);
  z-index: 5;
  height: 34px;
}
.ids-data-grid-header.is-frozen {
  z-index: 5;
}
.ids-data-grid-header.has-filter:has(.ids-data-grid-header-cell-filter-wrapper) {
  height: 62px;
}
.ids-data-grid-header.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {
  height: 78px;
}
.ids-data-grid-header {
  --ids-button-formatter-size: 28px;
}

.ids-data-grid-header-text .ids-data-grid-checkbox-container {
  width: 20px;
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container[disabled=true] {
  cursor: default;
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox[disabled=true] {
  pointer-events: none;
  opacity: var(--ids-data-grid-header-checkbox-opacity-disabled);
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {
  background-color: var(--ids-data-grid-header-checkbox-color-background);
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox:not(.checked):not(.indeterminate):not(:focus) {
  border-color: var(--ids-data-grid-header-checkbox-color-border);
}
.ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox:focus {
  border-color: var(--ids-checkbox-color-border-focus);
  box-shadow: var(--ids-shadow-20);
  outline: none;
}

.ids-data-grid-header-cell {
  box-sizing: border-box;
  border-inline-start: 1px solid var(--ids-data-grid-header-color-border);
  border-block-end: 1px solid var(--ids-data-grid-header-color-border);
  background-color: var(--ids-data-grid-header-color-background-default);
  min-height: 28px;
  position: relative;
  user-select: text;
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) {
  height: 62px;
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {
  height: 78px;
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-text {
  padding-block-end: var(--ids-space-2xs);
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper {
  height: var(--ids-data-grid-filter-height);
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper ids-menu-button {
  height: var(--ids-data-grid-filter-height);
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper ids-menu-button::part(button) {
  height: inherit;
}
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper ids-dropdown::part(triggerfield-field-container),
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper ids-input::part(field-container),
.has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper ids-trigger-field::part(field-container) {
  height: var(--ids-data-grid-filter-height);
}
.ids-data-grid-header-cell[hidden] {
  display: none;
}
.ids-data-grid-header-cell:first-child {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-header-cell:hover.is-actionable {
  background-color: var(--ids-data-grid-header-color-background-hover);
}
.ids-data-grid-header-cell:focus {
  outline: 1px solid var(--ids-color-border-focus);
  outline-offset: -1px;
  z-index: 5;
}
.ids-data-grid-header-cell:focus.is-focused {
  outline: none;
}
.ids-data-grid-header-cell:focus-within:has(.ids-data-grid-checkbox:focus) {
  outline: none;
}
.ids-data-grid-header-cell.align-center .ids-data-grid-header-cell-content, .ids-data-grid-header-cell.align-center .ids-data-grid-header-cell-filter-wrapper {
  justify-content: center;
}
.ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-content, .ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-filter-wrapper {
  justify-content: flex-end;
}
.ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {
  padding-inline-end: var(--ids-data-grid-padding-lg);
  padding-inline-start: 5px;
}
.ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-filter-wrapper ids-menu-button {
  margin-inline-start: var(--ids-space-3xs);
}
.ids-data-grid-header-cell .resizer {
  cursor: var(--ids-cursor-resize);
  display: inline;
  height: 100%;
  position: absolute;
  margin-inline-start: calc(100% - 4px);
  top: var(--ids-space-none);
  width: 6px;
  z-index: 2;
}
.ids-data-grid-header-cell .resizer .resize-indicator {
  position: relative;
  top: 21px;
  inset-inline-end: 7px;
  background-color: var(--ids-data-grid-header-resize-button-color);
  border-radius: var(--ids-border-radius-sm);
  box-shadow: var(--ids-box-shadow);
  z-index: 1;
}
.ids-data-grid-header-cell .resizer .resize-indicator ids-icon:first-child {
  transform: rotate(90deg);
  inset-inline-start: 2px;
}
.ids-data-grid-header-cell .resizer .resize-bar {
  border-inline-start: 2px solid var(--ids-data-grid-header-resize-bar-color);
  min-height: 500px;
  position: absolute;
  inset-inline-start: 50%;
}
.ids-data-grid-header-cell .reorderer {
  cursor: var(--ids-cursor-move);
  display: inline;
  height: 34px;
  opacity: 0;
  position: absolute;
  inset-inline-start: 5px;
  top: var(--ids-space-none);
  width: var(--ids-space-2xs);
}
.ids-data-grid-header-cell .reorderer ids-icon {
  position: absolute;
  color: var(--ids-data-grid-header-color-icon);
  inset-inline-start: calc(-1 * var(--ids-space-xs));
  text-align: center;
  top: calc(50% - 9px);
}
.ids-data-grid-header-cell.align-right .reorderer {
  inset-inline-end: 3px;
  inset-inline-start: initial;
}
.ids-data-grid-header-cell:last-child .resizer {
  margin-inline-start: calc(100% - 6px);
}
.ids-data-grid-header-cell.dragging {
  background-color: var(--ids-data-grid-header-drag-background-color) !important;
  border-inline-start: var(--ids-space-none);
  display: block;
  left: -1000px;
  position: absolute;
  top: var(--ids-space-none);
  width: 110px;
}
.ids-data-grid-header-cell.active-drag-column {
  background-color: var(--ids-data-grid-header-color-background-default-placeholder-dragging);
}
.ids-data-grid-header-cell.active-drag-column .sort-indicator {
  opacity: 0;
}
.ids-data-grid-header-cell:hover .reorderer {
  opacity: 1;
}
.ids-data-grid-header-cell.frozen {
  background-color: var(--ids-data-grid-header-color-background-default);
  position: sticky;
  z-index: 4;
}
.ids-data-grid-header-cell.frozen-last {
  border-inline-end: 1px solid var(--ids-data-grid-header-color-border);
}
.ids-data-grid-header-cell.frozen-last + .ids-data-grid-header-cell {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-header-cell.frozen-left {
  position: sticky;
  left: var(--ids-space-none);
  z-index: 2;
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(2) {
  left: var(--ids-data-grid-frozen-column-left-width-2);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(3) {
  left: var(--ids-data-grid-frozen-column-left-width-3);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(4) {
  left: var(--ids-data-grid-frozen-column-left-width-4);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(5) {
  left: var(--ids-data-grid-frozen-column-left-width-5);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(6) {
  left: var(--ids-data-grid-frozen-column-left-width-6);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(7) {
  left: var(--ids-data-grid-frozen-column-left-width-7);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(8) {
  left: var(--ids-data-grid-frozen-column-left-width-8);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(9) {
  left: var(--ids-data-grid-frozen-column-left-width-9);
}
.ids-data-grid-header-cell.frozen-left:nth-of-type(10) {
  left: var(--ids-data-grid-frozen-column-left-width-10);
}
.ids-data-grid-header-cell.frozen-right {
  position: sticky;
  right: var(--ids-space-none);
}
.ids-data-grid-header-cell.frozen-right .ids-data-grid-header-cell-content {
  display: inline-flex;
}

.ids-data-grid-header-cell.has-opacity {
  opacity: var(--ids-data-grid-header-cell-opacity, 0.2);
  pointer-events: none;
}

.ids-data-grid-header-cell-content {
  display: flex;
}

.ids-data-grid-header-text {
  display: block;
  padding: var(--ids-data-grid-header-lg-padding);
  font-weight: var(--ids-font-weight-semibold);
  font-size: var(--ids-data-grid-font-size-sm);
  color: var(--ids-data-grid-header-color-text);
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-data-grid-header-text small {
  font-weight: var(--ids-font-weight-normal);
  font-size: var(--ids-data-grid-font-size-sm);
}

.header-text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ids-data-grid-header-cell.is-required .header-text-content::after,
.ids-data-grid-header-cell.is-required .ids-checkbox .label-text::after {
  content: "*";
  color: var(--ids-input-required-indicator-color-text-default);
  margin-inline-start: var(--ids-space-3xs);
}

.ids-data-grid-header-icon {
  align-self: center;
  color: var(--ids-data-grid-header-color-text);
  margin-inline-start: var(--ids-space-2xs);
  margin-block-start: var(--ids-space-2xs);
}

.sort-indicator {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  overflow: hidden;
  height: calc(var(--ids-space-lg) - 2px);
  width: 18px;
}

.is-sortable .sort-indicator ids-icon {
  color: var(--ids-data-grid-header-color-icon-unsorted);
  opacity: 0;
  transition: opacity 0.3s var(--ids-motion-ease) 0s;
}
.is-sortable .sort-indicator ids-icon:first-child {
  position: relative;
  top: var(--ids-space-2xs);
  transform: rotate(180deg);
}
.is-sortable .sort-indicator ids-icon:last-child {
  position: relative;
  top: -10px;
}
.is-sortable:hover {
  cursor: pointer;
}
.is-sortable:hover .sort-indicator ids-icon {
  opacity: 1;
}

.header-expander {
  display: none;
  max-height: 18px;
  cursor: var(--ids-cursor-pointer);
  color: var(--ids-data-grid-header-expander-color);
  margin-inline-start: var(--ids-space-12);
}
.header-expander:hover {
  color: var(--ids-data-grid-header-expander-color-active);
}

[data-row-height=xxs] .header-expander {
  top: var(--ids-space-3xs);
}

:host([show-header-expander]) .header-expander,
.column-header-expander .header-expander {
  display: unset;
}

.has-selectioncheckbox .ids-data-grid-header-text:not(:focus-within) {
  padding-inline-start: var(--ids-space-none);
  padding-inline-end: var(--ids-space-none);
}

.is-sortable .ids-data-grid-header-text,
.has-headericon .ids-data-grid-header-text {
  padding-inline-end: var(--ids-space-none);
}

[aria-sort=ascending] .is-sortable .sort-indicator ids-icon:first-child {
  color: var(--ids-data-grid-header-color-icon-sorted);
  opacity: 1;
}
[aria-sort=ascending] .is-sortable .sort-indicator ids-icon:last-child {
  opacity: 1;
}

[aria-sort=descending] .is-sortable .sort-indicator ids-icon:first-child {
  opacity: 1;
}
[aria-sort=descending] .is-sortable .sort-indicator ids-icon:last-child {
  color: var(--ids-data-grid-header-color-icon-sorted);
  opacity: 1;
}

.ids-data-grid-sort-arrows {
  display: none;
  height: 34px;
  position: absolute;
  z-index: 2;
}
.ids-data-grid-sort-arrows::before, .ids-data-grid-sort-arrows::after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  content: "";
  display: inline-block;
  height: 0;
  left: -5px;
  position: absolute;
  width: 0;
}
.ids-data-grid-sort-arrows::before {
  border-top: 5px solid var(--ids-data-grid-header-drag-arrow-color-background);
  top: -6px;
}
.ids-data-grid-sort-arrows::after {
  border-bottom: 5px solid var(--ids-data-grid-header-drag-arrow-color-background);
  bottom: -9px;
}

tr.ids-data-grid-header {
  display: table-row;
  position: initial;
}

th.ids-data-grid-header-cell {
  display: table-cell;
}

.ids-data-grid.is-list-style .ids-data-grid-header-cell {
  background-color: var(--ids-data-grid-list-header-color-background);
  border-color: var(--ids-data-grid-list-header-color-border);
}
.ids-data-grid.is-list-style .ids-data-grid-header-text {
  color: var(--ids-data-grid-list-header-color-text);
}
.ids-data-grid.is-list-style .is-sortable ids-icon {
  color: var(--ids-data-grid-header-color-icon-unsorted);
}
.ids-data-grid.is-list-style [aria-sort=descending] .is-sortable ids-icon:last-child,
.ids-data-grid.is-list-style [aria-sort=ascending] .is-sortable ids-icon:first-child {
  color: var(--ids-data-grid-list-header-color-icon-unsorted);
}
.ids-data-grid.is-list-style .ids-data-grid-header-text .ids-data-grid-checkbox-container .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {
  border-color: var(--ids-data-grid-list-header-checkbox-color-background);
}

.ids-data-grid-body {
  min-width: fit-content;
}

.ids-data-grid[data-row-height=md] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-md-padding);
}
.ids-data-grid[data-row-height=md] .sort-indicator {
  margin-inline-start: -8px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-header-cell.align-right .reorderer {
  inset-inline-end: 3px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-text {
  padding-block-end: var(--ids-space-2xs);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-sm-padding);
}
.ids-data-grid[data-row-height=sm] .reorderer {
  display: none;
}
.ids-data-grid[data-row-height=sm] .sort-indicator {
  margin-inline-start: -4px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-text {
  padding-block-end: var(--ids-space-2xs);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) .ids-data-grid-header-cell-filter-wrapper {
  padding-inline: var(--ids-space-xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header {
  height: 30px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {
  height: 78px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header.has-filter:has(.ids-data-grid-header-cell-filter-wrapper) {
  height: 60px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header-cell {
  min-height: 30px;
}
.has-filter .ids-data-grid[data-row-height=xs] .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) {
  height: 60px;
}
.ids-data-grid[data-row-height=xs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {
  height: 78px;
}
.ids-data-grid[data-row-height=xs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) {
  height: 60px;
}
.ids-data-grid[data-row-height=xs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) .ids-data-grid-header-text {
  padding-block-end: var(--ids-space-2xs);
}
.ids-data-grid[data-row-height=xs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) .ids-data-grid-header-cell-filter-wrapper {
  padding-inline: var(--ids-space-2xs);
  padding-block-end: 6px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-xs-padding);
}
.ids-data-grid[data-row-height=xs] .reorderer {
  display: none;
}
.ids-data-grid[data-row-height=xs] .sort-indicator {
  margin-inline-start: -2px;
  margin-inline-end: -2px;
  margin-block-start: -3px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-checkbox-container {
  padding-top: var(--ids-space-3xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {
  padding-inline-end: var(--ids-data-grid-padding-xs);
  padding-inline-start: 5px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header {
  height: 30px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header:has(br) {
  height: 62px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {
  height: 70px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) {
  height: 60px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-cell {
  min-height: 30px;
}
.has-filter .ids-data-grid[data-row-height=xxs] .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) {
  height: 60px;
}
.ids-data-grid[data-row-height=xxs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {
  height: 70px;
}
.ids-data-grid[data-row-height=xxs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) {
  height: 60px;
}
.ids-data-grid[data-row-height=xxs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) .ids-data-grid-header-text {
  padding: var(--ids-space-2xs);
  padding-block-start: 6px;
}
.ids-data-grid[data-row-height=xxs] .has-filter .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) .ids-data-grid-header-cell-filter-wrapper {
  padding-inline: var(--ids-space-2xs);
  padding-block-end: 6px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-text {
  padding: var(--ids-data-grid-header-xxs-padding);
}
.ids-data-grid[data-row-height=xxs] .reorderer {
  display: none;
}
.ids-data-grid[data-row-height=xxs] .sort-indicator {
  margin-inline-start: var(--ids-space-none);
  margin-block-start: -1px;
  height: 22px;
}
.ids-data-grid[data-row-height=xxs] .sort-indicator > ids-icon:first-child {
  top: 3px;
}
.ids-data-grid[data-row-height=xxs] .sort-indicator ids-icon:last-child {
  top: -11px;
}
.ids-data-grid[data-row-height=xxs] .align-right .sort-indicator {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-text .ids-data-grid-checkbox-container {
  padding-top: 3px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-cell.align-right .is-sortable .ids-data-grid-header-text {
  padding-inline-end: 3px;
  padding-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] ids-input,
.ids-data-grid[data-row-height=xxs] ids-menu-button,
.ids-data-grid[data-row-height=xxs] ids-trigger-field,
.ids-data-grid[data-row-height=xxs] ids-dropdown {
  --ids-input-height-10: 24px;
}
.ids-data-grid[data-row-height=xxs] ids-dropdown {
  --ids-input-font-size-sm: var(--ids-input-font-size-xs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-header-cell-filter-wrapper {
  padding-inline-start: calc(var(--ids-data-grid-padding-xxs) + 2px);
  padding-inline-end: calc(var(--ids-data-grid-padding-xxs) + 2px);
  padding-block-end: calc(var(--ids-data-grid-padding-xxs) - 1px);
}

.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content {
  justify-content: flex-start;
}
.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content .ids-data-grid-header-text .ids-checkbox .label-text {
  position: absolute;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
}
.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content.is-sortable .ids-data-grid-header-text .ids-checkbox .label-text, .ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content.is-reorderable .ids-data-grid-header-text .ids-checkbox .label-text {
  width: 70%;
}
.ids-data-grid .has-col-selection .ids-data-grid-header-cell:not([column-id=selectionCheckbox]) .ids-data-grid-header-cell-content.is-sortable.is-reorderable .ids-data-grid-header-text .ids-checkbox .label-text {
  width: 60%;
}
.ids-data-grid .has-col-selection .sort-indicator {
  margin-inline-start: auto;
}

:host([dir=rtl]) .ids-data-grid-header-cell.align-right .ids-data-grid-header-cell-content {
  direction: ltr;
}
:host([dir=rtl]) .ids-data-grid-header-cell:last-child {
  border-inline-end-width: var(--ids-border-width-none);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left {
  position: sticky;
  right: var(--ids-space-none);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(2) {
  right: var(--ids-data-grid-frozen-column-left-width-2);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(3) {
  right: var(--ids-data-grid-frozen-column-left-width-3);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(4) {
  right: var(--ids-data-grid-frozen-column-left-width-4);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(5) {
  right: var(--ids-data-grid-frozen-column-left-width-5);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(6) {
  right: var(--ids-data-grid-frozen-column-left-width-6);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(7) {
  right: var(--ids-data-grid-frozen-column-left-width-7);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(8) {
  right: var(--ids-data-grid-frozen-column-left-width-8);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(9) {
  right: var(--ids-data-grid-frozen-column-left-width-9);
}
:host([dir=rtl]) .ids-data-grid-header-cell.frozen-left:nth-of-type(10) {
  right: var(--ids-data-grid-frozen-column-left-width-10);
}

/* Ids Data Grid Component - Rows */
.ids-data-grid-row {
  display: contents;
  width: 100%;
  height: inherit;
}
.ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {
  height: auto;
  min-height: var(--ids-data-grid-row-height-lg);
  line-height: var(--ids-data-grid-line-height-lg);
  align-items: center;
}
.ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell, .ids-data-grid-row.activated .ids-data-grid-cell, .ids-data-grid-row.selected:not(.mixed):hover .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-selected);
  border-color: var(--ids-data-grid-cell-color-border-selected);
}
.ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell:focus, .ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell.is-focused, .ids-data-grid-row.activated .ids-data-grid-cell:focus, .ids-data-grid-row.activated .ids-data-grid-cell.is-focused, .ids-data-grid-row.selected:not(.mixed):hover .ids-data-grid-cell:focus, .ids-data-grid-row.selected:not(.mixed):hover .ids-data-grid-cell.is-focused {
  border-color: var(--ids-color-border-focus);
}
.ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {
  background-color: var(--ids-data-grid-row-color-background-selected);
}
.ids-data-grid-row[hidden] {
  display: none;
}
.ids-data-grid-row[part*=row-] .ids-data-grid-cell:first-child::before {
  border-style: solid;
  border-width: 5px;
  content: "";
  position: absolute;
  z-index: 1;
  margin: 2px;
  top: 0;
}
.ids-data-grid-row[part=row-new] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-new) transparent transparent var(--ids-data-grid-row-color-border-new);
}
.ids-data-grid-row[part=row-new] .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-new);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[part=row-removed] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-removed) transparent transparent var(--ids-data-grid-row-color-border-removed);
}
.ids-data-grid-row[part=row-removed] .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-removed);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[part=row-error] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-error) transparent transparent var(--ids-data-grid-row-color-border-error);
}
.ids-data-grid-row[part=row-error] .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-error);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[part=row-warning] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-warning) transparent transparent var(--ids-data-grid-row-color-border-warning);
}
.ids-data-grid-row[part=row-warning] .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-color-background-warning);
  color: var(--ids-data-grid-cell-color-text-states-default);
}
.ids-data-grid-row[aria-expanded=true] .ids-data-grid-cell {
  background-color: var(--ids-data-grid-expandable-areas-color-background-default);
}

.ids-data-grid-row.is-group-row .ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-grouped-color-background);
  color: var(--ids-data-grid-row-grouped-color-text);
  font-weight: var(--ids-data-grid-row-grouped-font-weight, 600);
  border-inline-start: 0;
  grid-column: 1/-1;
}
.ids-data-grid-row.is-group-row ids-button {
  --ids-button-tertiary-color-background-hover: transparent;
  --ids-button-tertiary-color-border-hover: transparent;
  padding: 0 2px;
}

.ids-data-grid[data-row-height=md] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-md);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=md] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-md);
  padding-inline-end: var(--ids-data-grid-padding-md);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {
  min-height: var(--ids-data-grid-row-height-md);
  line-height: var(--ids-data-grid-line-height-md);
  height: auto;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-md);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-md);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-sm);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-sm);
  padding-inline-end: var(--ids-data-grid-padding-sm);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {
  min-height: var(--ids-data-grid-row-height-sm);
  height: auto;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell .text-multiline {
  padding: var(--ids-data-grid-padding-sm);
  line-height: var(--ids-data-grid-line-height-sm);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-sm);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-sm);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-xs);
  font-size: var(--ids-data-grid-font-size-sm);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-xs);
  padding-inline-end: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {
  min-height: var(--ids-data-grid-row-height-xs);
  height: auto;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell .text-multiline {
  padding: var(--ids-data-grid-padding-xs);
  line-height: var(--ids-data-grid-line-height-xs);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xs);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell {
  height: var(--ids-data-grid-row-height-xxs);
  font-size: var(--ids-data-grid-font-size-sm);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell .text-ellipsis,
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-data-grid-padding-xxs);
  padding-inline-end: var(--ids-data-grid-padding-xxs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-inline .text-ellipsis {
  padding-inline-start: var(--ids-data-grid-padding-xs);
  padding-inline-end: var(--ids-data-grid-padding-xs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {
  min-height: var(--ids-data-grid-row-height-xxs);
  height: auto;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell .text-multiline {
  padding: var(--ids-data-grid-padding-xxs);
  line-height: var(--ids-data-grid-line-height-xxs);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xxs);
  transition: padding var(--ids-motion-duration) var(--ids-motion-ease);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {
  padding-inline-start: var(--ids-data-grid-padding-xxs);
}
.ids-data-grid.is-list-style .ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell {
  border-inline-start-color: transparent;
}
.ids-data-grid.is-list-style .ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell:focus {
  border-inline-start-color: var(--ids-color-border-focus);
}

.ids-data-grid.alt-row-shading ids-data-grid-row:nth-child(even) ids-data-grid-cell {
  background-color: var(--ids-data-grid-row-alternating-color-background);
}

.ids-data-grid-expandable-row {
  border-bottom: 1px solid var(--ids-data-grid-cell-color-border);
  background-color: var(--ids-data-grid-expandable-areas-color-background-default);
  grid-column: 1/-1;
  padding: var(--ids-space-xs);
}

tr.ids-data-grid-row {
  display: table-row;
  height: var(--ids-data-grid-row-height-lg);
}

.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row:focus-within .ids-data-grid-cell {
  border-block: 1px solid var(--ids-color-border-focus);
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row:focus-within .ids-data-grid-cell:first-child {
  border-inline-start: 1px solid var(--ids-color-border-focus);
  position: relative;
  z-index: 1;
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row:focus-within .ids-data-grid-cell:last-child {
  border-inline-end: 1px solid var(--ids-color-border-focus);
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row .ids-data-grid-cell:focus {
  box-shadow: none;
  outline: none;
}
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row ids-hyperlink,
.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row .ids-hyperlink {
  transform: translateZ(1px);
}

:host([dir=rtl]) .ids-data-grid-row[part=row-new] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-new) var(--ids-data-grid-row-color-border-new) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-row[part=row-removed] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-removed) var(--ids-data-grid-row-color-border-removed) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-row[part=row-warning] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-warning) var(--ids-data-grid-row-color-border-warning) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-row[part=row-error] .ids-data-grid-cell:first-child::before {
  border-color: var(--ids-data-grid-row-color-border-error) var(--ids-data-grid-row-color-border-error) transparent transparent;
}

/* Ids Data Grid Component - Cells */
/* Generates a pseudo-element representing the dirty tracker */
/* Generates a pseudo-element representing the field indicator */
ids-data-grid-cell[column-onscreen] {
  visibility: visible;
}

ids-data-grid-cell[column-offscreen] {
  visibility: visible;
}

ids-data-grid-cell[column-offscreen-left] {
  visibility: visible;
}

ids-data-grid-cell[column-offscreen-right] {
  visibility: visible;
}

.ids-data-grid-row:not(.selected):not([part*=row-]) .ids-data-grid-cell:not(.is-readonly).frozen-left {
  background-color: var(--ids-data-grid-color-background);
}
.ids-data-grid-row:not(.selected):not([part*=row-]) .ids-data-grid-cell:not(.is-readonly).frozen-right {
  background-color: var(--ids-data-grid-color-background);
}

.ids-data-grid-cell {
  box-sizing: border-box;
  align-items: center;
  border-inline-start: 1px solid;
  border-block-end: 1px solid;
  border-color: var(--ids-data-grid-cell-color-border);
  display: inline-flex;
  color: var(--ids-data-grid-cell-color-text-default);
  height: 50px;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
}
.ids-data-grid-cell:not([hidden]):not([skipped-cell]):first-child {
  border-inline-start-width: var(--ids-border-width-none);
}
.ids-data-grid-cell ids-badge::part(badge) {
  margin-block-end: var(--ids-space-none);
  margin-inline-end: var(--ids-space-none);
}
.ids-data-grid-cell ids-badge {
  padding-inline-start: var(--ids-space-sm);
  padding-inline-end: var(--ids-space-sm);
}
.ids-data-grid-cell ids-icon[icon=dropdown] {
  color: var(--ids-trigger-field-icon-color);
}
.ids-data-grid-cell ids-hyperlink {
  margin: 0;
  padding-inline: 12px;
  height: 20px;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
}
.ids-data-grid-cell.formatter-hyperlink.has-editor-dropdown ids-hyperlink {
  width: auto;
  display: inline-block;
  max-width: 100%;
}
.ids-data-grid-cell .text-ellipsis {
  display: inline-block;
  vertical-align: middle;
  padding-inline-start: calc(var(--ids-space-xs) + 4px);
  padding-inline-end: calc(var(--ids-space-xs) + 4px);
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ids-data-grid-cell .has-indicator {
  display: flex;
}
.ids-data-grid-cell .text-multiline {
  display: inline-block;
  vertical-align: middle;
  padding: calc(var(--ids-space-xs) + 4px);
  white-space: normal;
}
.ids-data-grid-cell.formatter-textarea {
  height: auto;
  min-height: var(--ids-data-grid-row-height-lg);
  align-items: flex-start;
  white-space: pre-line;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}
.ids-data-grid-cell ids-icon {
  vertical-align: middle;
}
.ids-data-grid-cell ids-icon + span {
  vertical-align: middle;
  line-height: 25px;
  padding-inline: var(--ids-space-2xs);
}
.ids-data-grid-cell .row-number-indicator {
  color: var(--ids-data-grid-row-indicator-color-icon);
  margin-inline-end: var(--ids-space-2xs);
}
.ids-data-grid-cell .row-number-indicator-spacer {
  display: inline-block;
  width: 16px;
  margin-inline-end: var(--ids-space-2xs);
}
.ids-data-grid-cell.align-center > *:first-child {
  display: inline-flex;
  margin: var(--ids-space-none) auto;
}
.ids-data-grid-cell.align-right > *:first-child {
  margin-inline-start: auto;
  margin-inline-end: var(--ids-space-none);
}
.ids-data-grid-cell.align-right ids-input {
  text-align: right;
}
.ids-data-grid-cell.is-readonly:not(.exclude-readonly-style):not(.selected) {
  background-color: var(--ids-data-grid-cell-color-background-frozen-readonly);
}
.ids-data-grid-cell.is-readonly:not(.exclude-readonly-style):not(.selected) .editor-cell-icon {
  display: none;
}
.ids-data-grid-cell.is-disabled {
  color: var(--ids-data-grid-cell-color-text-disabled);
}
.ids-data-grid-cell.is-disabled .editor-cell-icon {
  display: none;
}
.ids-data-grid-cell.is-uppercase {
  text-transform: uppercase;
}
.ids-data-grid-cell:focus:not(.selected):not([tabindex="-1"]), .ids-data-grid-cell.is-editing:not(.is-inline):focus-within:not(.selected):not([tabindex="-1"]), .ids-data-grid-cell.is-focused:not(.selected):not([tabindex="-1"]) {
  box-shadow: var(--ids-shadow-20);
  outline: none;
  border: 1px solid var(--ids-color-border-focus);
  z-index: 1;
}
.ids-data-grid-cell:focus:not(.selected):not([tabindex="-1"]).frozen, .ids-data-grid-cell.is-editing:not(.is-inline):focus-within:not(.selected):not([tabindex="-1"]).frozen, .ids-data-grid-cell.is-focused:not(.selected):not([tabindex="-1"]).frozen {
  z-index: 3;
}
.ids-data-grid-cell.formatter-textmask.is-hoverable {
  justify-content: space-between;
}
.ids-data-grid-cell.formatter-textmask.is-hoverable .text-ellipsis {
  padding-inline-end: var(--ids-space-sm);
}
.ids-data-grid-cell.formatter-textmask .editor-cell-icon {
  margin-inline-end: 10px;
  margin-block-start: var(--ids-space-3xs);
  display: none;
}
.ids-data-grid-cell.formatter-textmask .editor-cell-icon.show-cell-icon-always {
  display: inline-flex;
}
.ids-data-grid-cell.formatter-textmask .editor-cell-icon.show-cell-icon-always:hover {
  cursor: pointer;
}
.ids-data-grid-cell.formatter-textmask:not(.is-inline):not(.is-invalid):hover .editor-cell-icon, .ids-data-grid-cell.formatter-textmask.is-editing .editor-cell-icon {
  display: flex;
}
.ids-data-grid-cell.formatter-textmask:not(.is-inline):not(.is-invalid):hover .text-ellipsis, .ids-data-grid-cell.formatter-textmask.is-editing .text-ellipsis {
  padding-inline-end: var(--ids-space-08);
}
.ids-data-grid-cell.formatter-textmask:not(.is-inline):not(.is-invalid):hover ids-alert, .ids-data-grid-cell.formatter-textmask.is-editing ids-alert {
  margin-inline: calc(100% - 48px);
}
.ids-data-grid-cell.is-editable.is-readonly:not(.exclude-readonly-style) .text-ellipsis::after {
  background-color: var(--ids-data-grid-cell-color-background-readonly);
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .ids-data-grid-tree-container {
  height: 100%;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .ids-data-grid-tree-field-container {
  height: 100%;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: end;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -8px;
}
.ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  display: inline-flex;
  visibility: visible;
  margin-inline-end: 15px;
}
.ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon[icon=dropdown] {
  margin-inline-end: 12px;
}
.ids-data-grid-cell.is-editable.is-lookup, .ids-data-grid-cell.is-editable.is-datepicker, .ids-data-grid-cell.is-editable.is-timepicker {
  justify-content: space-between;
}
.ids-data-grid-cell.is-editable.is-lookup .text-ellipsis, .ids-data-grid-cell.is-editable.is-datepicker .text-ellipsis, .ids-data-grid-cell.is-editable.is-timepicker .text-ellipsis {
  padding-inline-end: var(--ids-space-none);
}
.ids-data-grid-cell.is-editable.is-datepicker ids-trigger-field, .ids-data-grid-cell.is-editable.is-timepicker ids-trigger-field {
  margin-inline-start: -1px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editable.is-lookup ids-lookup {
  border: 0;
  outline: none;
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-lookup ids-lookup::part(container),
.ids-data-grid-cell.is-editable.is-lookup ids-lookup::part(field-container) {
  background-color: var(--ids-color-transparent);
  border: 0;
  border-radius: 0;
  box-shadow: none;
  outline: none;
  height: 100%;
  width: 100%;
  display: flex;
  margin: 0;
}
.ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: 6px;
  margin-block-start: var(--ids-space-3xs);
  display: none;
}
.ids-data-grid-cell.is-editable .editor-cell-icon.show-cell-icon-always {
  display: inline-flex;
}
.ids-data-grid-cell.is-editable .editor-cell-icon.show-cell-icon-always:hover {
  cursor: pointer;
}
.ids-data-grid-cell.is-editable ids-trigger-button::part(button) {
  color: inherit;
}
.ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):not(.is-readonly):focus .editor-cell-icon, .ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):not(.is-readonly):hover .editor-cell-icon {
  display: flex;
}
.ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):not(.is-readonly):focus ids-alert, .ids-data-grid-cell.is-editable:not(.is-inline):not(.is-invalid):not(.is-readonly):hover ids-alert {
  margin-inline: calc(100% - 48px);
}
.ids-data-grid-cell.is-editable.is-editable.is-invalid {
  justify-content: space-between;
}
.ids-data-grid-cell.is-editable.is-editable.is-invalid.formatter-hyperlink.has-editor-dropdown {
  justify-content: end;
}
.ids-data-grid-cell.is-editable.is-editable.is-invalid ids-alert {
  margin-inline-end: 7px;
}
.ids-data-grid-cell.is-editing:not(.is-multiselect) ids-checkbox {
  --ids-checkbox-margin-inline-end: 0;
  --ids-checkbox-shadow-focus: 0 0 0 2px transparent, 0 0 0 3px transparent;
  --ids-checkbox-color-border-focus: var(--ids-checkbox-border);
}
.ids-data-grid-cell.is-editing:not(.is-multiselect) ids-checkbox[checked] {
  --ids-checkbox-color-border-focus: var(
    --ids-checkbox-color-background-selected
  );
}
.ids-data-grid-cell.is-editing:not(.is-multiselect) ids-checkbox {
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
  left: 6px;
  top: 3px;
}
.ids-data-grid-cell.is-editing.is-lookup, .ids-data-grid-cell.is-editing.is-datepicker, .ids-data-grid-cell.is-editing.is-timepicker, .ids-data-grid-cell.is-editing.is-password {
  overflow: visible;
}
.ids-data-grid-cell.is-editing.is-inline ids-input {
  z-index: 99;
}
.ids-data-grid-cell.is-editable.is-dropdown .dropdown-cell-value {
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-dropdown.is-editing:not(.is-inline) {
  border-inline-start-width: 0;
}
.ids-data-grid-cell.is-editable.is-multiselect .multiselect-cell-value {
  width: 100%;
}
.ids-data-grid-cell.is-editable.is-multiselect.is-editing:not(.is-inline) {
  border-inline-start-width: 0;
}
.ids-data-grid-cell.is-editing.is-dropdown.is-inline {
  box-shadow: none;
}
.ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {
  padding: 0 var(--ids-space-2xs);
}
.ids-data-grid-cell.formatter-text {
  white-space: pre;
}
.ids-data-grid-cell.white-space-normal {
  white-space: normal;
}
.ids-data-grid-cell.white-space-nowrap {
  white-space: nowrap;
}
.ids-data-grid-cell.white-space-pre {
  white-space: pre;
}
.ids-data-grid-cell.white-space-pre-line {
  white-space: pre-line;
}
.ids-data-grid-cell.white-space-pre-wrap {
  white-space: pre-wrap;
}
.ids-data-grid-cell.white-space-break-spaces {
  white-space: break-spaces;
}
.ids-data-grid-cell[hidden] {
  display: none;
}
.ids-data-grid-cell.formatter-row-reorder {
  cursor: move;
}
.ids-data-grid-cell.is-editing.is-uppercase {
  text-transform: uppercase;
}
.ids-data-grid-cell.is-editing.is-uppercase ids-list-box-option,
.ids-data-grid-cell.is-editing.is-uppercase ids-dropdown::part(triggerfield-input),
.ids-data-grid-cell.is-editing.is-uppercase ids-input::part(input) {
  text-transform: uppercase;
}
.ids-data-grid-cell.frozen {
  position: sticky;
  background-color: var(--ids-data-grid-color-background);
  z-index: 2;
}
.ids-data-grid-cell.frozen-last {
  border-inline-end: 1px solid var(--ids-data-grid-cell-color-border);
}
.ids-data-grid-cell.frozen-last + .ids-data-grid-cell {
  border-inline-start: none;
}
.ids-data-grid-cell.frozen-last + .ids-data-grid-cell[hidden] + .ids-data-grid-cell {
  border-inline-start: none;
}
.ids-data-grid-cell.frozen-left {
  position: sticky;
  left: var(--ids-space-none);
}
.ids-data-grid-cell.frozen-left:nth-of-type(2) {
  left: var(--ids-data-grid-frozen-column-left-width-2);
}
.ids-data-grid-cell.frozen-left:nth-of-type(3) {
  left: var(--ids-data-grid-frozen-column-left-width-3);
}
.ids-data-grid-cell.frozen-left:nth-of-type(4) {
  left: var(--ids-data-grid-frozen-column-left-width-4);
}
.ids-data-grid-cell.frozen-left:nth-of-type(5) {
  left: var(--ids-data-grid-frozen-column-left-width-5);
}
.ids-data-grid-cell.frozen-left:nth-of-type(6) {
  left: var(--ids-data-grid-frozen-column-left-width-6);
}
.ids-data-grid-cell.frozen-left:nth-of-type(7) {
  left: var(--ids-data-grid-frozen-column-left-width-7);
}
.ids-data-grid-cell.frozen-left:nth-of-type(8) {
  left: var(--ids-data-grid-frozen-column-left-width-8);
}
.ids-data-grid-cell.frozen-left:nth-of-type(9) {
  left: var(--ids-data-grid-frozen-column-left-width-9);
}
.ids-data-grid-cell.frozen-left:nth-of-type(10) {
  left: var(--ids-data-grid-frozen-column-left-width-10);
}
.ids-data-grid-cell.frozen-right {
  position: sticky;
  right: var(--ids-space-none);
}
.ids-data-grid-cell.is-dirty::before {
  border-color: var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent var(--ids-input-dirty-indicator-color-background-dirty);
  border-style: solid;
  border-width: 5px;
  content: "";
  display: inline-block;
  margin-inline: var(--ids-space-3xs);
  position: absolute;
  inset-block-start: var(--ids-space-3xs);
  z-index: 1;
}
.ids-data-grid-cell.has-field-indicator::before {
  border-style: solid;
  border-width: 5px;
  content: "";
  display: inline-block;
  margin-inline: var(--ids-space-3xs);
  position: absolute;
  inset-block-start: var(--ids-space-3xs);
  z-index: 1;
}
.ids-data-grid-cell.field-indicator-neutral::before {
  border-color: var(--ids-color-accent-neutral-weak) transparent transparent var(--ids-color-accent-neutral-weak);
}
.ids-data-grid-cell.field-indicator-info::before {
  border-color: var(--ids-color-info-default) transparent transparent var(--ids-color-info-default);
}
.ids-data-grid-cell.field-indicator-success::before {
  border-color: var(--ids-color-success-default) transparent transparent var(--ids-color-success-default);
}
.ids-data-grid-cell.field-indicator-caution::before {
  border-color: var(--ids-color-caution-default) transparent transparent var(--ids-color-caution-default);
}
.ids-data-grid-cell.field-indicator-warning::before {
  border-color: var(--ids-color-warning-default) transparent transparent var(--ids-color-warning-default);
}
.ids-data-grid-cell.field-indicator-error::before {
  border-color: var(--ids-color-error-default) transparent transparent var(--ids-color-error-default);
}
.ids-data-grid-cell .cell-field-indicator-icon {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  inset-inline-end: var(--ids-space-xs);
  top: 50%;
  transform: translateY(-50%);
}
.ids-data-grid-cell.field-indicator-neutral .cell-field-indicator-icon {
  color: var(--ids-color-accent-neutral-weak);
}
.ids-data-grid-cell.field-indicator-info .cell-field-indicator-icon {
  color: var(--ids-color-info-default);
}
.ids-data-grid-cell.field-indicator-success .cell-field-indicator-icon {
  color: var(--ids-color-success-default);
}
.ids-data-grid-cell.field-indicator-caution .cell-field-indicator-icon {
  color: var(--ids-color-caution-default);
}
.ids-data-grid-cell.field-indicator-warning .cell-field-indicator-icon {
  color: var(--ids-color-warning-default);
}
.ids-data-grid-cell.field-indicator-error .cell-field-indicator-icon {
  color: var(--ids-color-error-default);
}
.ids-data-grid-cell.has-field-indicator .text-ellipsis {
  padding-inline-end: calc(var(--ids-space-xs) + 20px);
}
.ids-data-grid-cell.is-editing .cell-field-indicator-icon {
  display: none;
}
.ids-data-grid-cell.is-dirty.is-inline.formatter-tree::before {
  display: none;
  content: none;
}
.ids-data-grid-cell.is-dirty.is-inline.formatter-tree .ids-data-grid-tree-field-container {
  position: relative;
}
.ids-data-grid-cell.is-dirty.is-inline.formatter-tree .ids-data-grid-tree-field-container::before {
  border-color: var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent var(--ids-input-dirty-indicator-color-background-dirty);
  border-style: solid;
  border-width: 5px;
  content: "";
  display: inline-block;
  margin-inline: var(--ids-space-3xs);
  position: absolute;
  inset-block-start: var(--ids-space-3xs);
  z-index: 1;
}
.ids-data-grid-cell.is-dirty.is-inline.is-dropdown::before {
  margin-inline: 6px;
  inset-block-start: 6px;
}
.ids-data-grid-cell.is-dirty.is-inline ids-input::part(dirty-tracker-icon) {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
}
.ids-data-grid-cell.is-dirty.is-dropdown.is-editing:not(.is-inline)::before {
  inset-block-start: 3px;
  margin-inline: 3px;
}
.ids-data-grid-cell.is-invalid {
  background-color: var(--ids-data-grid-cell-color-background-error);
}
.ids-data-grid-cell.is-invalid.has-field-indicator ids-alert[icon=error] {
  display: none;
}
.ids-data-grid-cell.selected {
  background-color: var(--ids-data-grid-row-color-background-selected);
}
.ids-data-grid-cell ids-alert {
  margin-top: 3px;
}
.ids-data-grid-cell ids-tag {
  --ids-tag-margin-inline-end: 0;
}
.ids-data-grid-cell ids-progress-bar {
  margin: var(--ids-progress-bar-grid-cell-margin);
}
.ids-data-grid-cell.is-editing.is-timepicker .ids-trigger-field-slot-trigger-end[icon=clock][field-height=xs] {
  margin-inline-end: -3px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editing.is-timepicker .ids-trigger-field-slot-trigger-end[icon=clock][field-height=sm] {
  margin-inline-end: 2px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editing.is-datepicker .ids-trigger-field-slot-trigger-end[icon=calendar][field-height=xs] {
  margin-inline-end: -3px;
  margin-block-start: 1px;
}
.ids-data-grid-cell.is-editing.is-datepicker .ids-trigger-field-slot-trigger-end[icon=calendar][field-height=sm] {
  margin-inline-end: 2px;
  margin-block-start: 1px;
}

[data-row-height=xxs] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-xxs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-dirty::before {
  border-width: 4px;
  inset-block-start: 1px;
  inset-inline-start: -1px;
}
[data-row-height=xxs] .ids-data-grid-cell.is-dirty.is-inline::before {
  margin-inline: 3px;
  top: 3px;
}
[data-row-height=xxs] ids-button {
  --ids-button-icon-padding: var(--ids-space-3xs);
}
[data-row-height=xxs] ids-badge {
  --ids-badge-font-line-height: calc(
    var(--ids-data-grid-row-height-xxs) - 8px
  );
}
[data-row-height=xxs] ids-tag {
  --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 6px);
}
[data-row-height=xxs] ids-input,
[data-row-height=xxs] ids-trigger-field {
  --ids-space-3xs: 0;
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xxs] ids-input::part(dirty-tracker-icon) {
  --ids-icon-height-default: 10px !important;
  --ids-icon-width-default: 10px !important;
}
[data-row-height=xxs] ids-input::part(input) {
  height: calc(var(--ids-input-height-10));
}
[data-row-height=xxs] .ids-data-grid-cell.is-editing ids-input::part(input) {
  height: calc(var(--ids-input-height-10) - 4px);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: var(--ids-space-3xs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: var(--ids-space-2xs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {
  padding: var(--ids-space-none) var(--ids-space-4xs);
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xxs] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-xxs);
}
[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-editable.is-invalid ids-alert {
  margin-inline-end: var(--ids-space-4xs);
}
[data-row-height=xxs] .ids-data-grid-cell ids-hyperlink {
  padding-inline: var(--ids-space-2xs);
}

[data-row-height=xs] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-xs);
}
[data-row-height=xs] .ids-data-grid-cell.is-dirty::before {
  border-width: 4px;
}
[data-row-height=xs] .ids-data-grid-cell.is-dirty.is-inline::before {
  margin-inline: 3px;
  top: 3px;
}
[data-row-height=xs] ids-button {
  --ids-button-icon-padding: 3px;
}
[data-row-height=xs] ids-badge {
  --ids-badge-font-line-height: calc(
    var(--ids-data-grid-row-height-xs) - 12px
  );
}
[data-row-height=xs] ids-tag {
  --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 4px);
}
[data-row-height=xs] ids-input {
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xs] ids-input::part(dirty-tracker-icon) {
  --ids-icon-height-default: 12px !important;
  --ids-icon-width-default: 12px !important;
}
[data-row-height=xs] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: var(--ids-space-3xs);
}
[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: var(--ids-space-2xs);
}
[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);
}
[data-row-height=xs] .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {
  padding: var(--ids-space-none) var(--ids-space-3xs);
}
[data-row-height=xs] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-xs);
}
[data-row-height=xs] .ids-data-grid-cell ids-hyperlink {
  padding-inline: var(--ids-space-2xs);
}

[data-row-height=sm] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-sm);
}
[data-row-height=sm] ids-button {
  --ids-button-icon-padding: var(--ids-space-2xs);
}
[data-row-height=sm] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: 7px;
}
[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: 5px;
  margin-block-start: 0;
}
[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
}
[data-row-height=sm] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-sm);
}
[data-row-height=sm] .ids-data-grid-cell ids-hyperlink {
  padding-inline: var(--ids-space-xs);
}

[data-row-height=md] .formatter-progress ids-progress-bar {
  margin: var(--ids-data-grid-padding-md);
}
[data-row-height=md] .ids-data-grid-cell.is-editable .editor-cell-icon {
  margin-inline-end: 6px;
}
[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {
  margin-inline-end: var(--ids-data-grid-padding-sm);
}
[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
}
[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline ::slotted(ids-trigger-button) {
  position: relative;
  top: 100px;
}
[data-row-height=md] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-md);
}

[data-row-height=lg] .ids-data-grid-cell .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {
  padding-inline: var(--ids-data-grid-padding-lg);
}

.ids-data-grid.is-list-style .ids-data-grid-cell {
  border-inline-start: 1px solid transparent;
  border-bottom: 1px solid var(--ids-data-grid-list-cell-color-border);
}
.ids-data-grid.is-list-style .ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {
  background-color: var(--ids-data-grid-cell-color-background-readonly);
}
.ids-data-grid.is-list-style .ids-data-grid-cell.is-disabled {
  color: var(--ids-data-grid-cell-color-text-disabled);
}
.ids-data-grid.is-list-style .ids-data-grid-cell:not([hidden]):not([skipped-cell]):first-child {
  border-inline-start-width: 1px;
}
.ids-data-grid.is-list-style .ids-data-grid-body .ids-data-grid-row:first-child .ids-data-grid-cell:not(:focus):not(.is-focused):not(.is-editing) {
  border-top: 0;
}

td.ids-data-grid-cell {
  display: table-cell;
  padding-inline-start: var(--ids-space-sm);
  padding-inline-end: var(--ids-space-sm);
}

:host([dir=rtl]) .ids-data-grid.is-list-style .ids-data-grid-cell {
  border-inline-end-width: var(--ids-border-width-none);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left {
  position: sticky;
  right: var(--ids-space-none);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(2) {
  right: var(--ids-data-grid-frozen-column-left-width-2);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(3) {
  right: var(--ids-data-grid-frozen-column-left-width-3);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(4) {
  right: var(--ids-data-grid-frozen-column-left-width-4);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(5) {
  right: var(--ids-data-grid-frozen-column-left-width-5);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(6) {
  right: var(--ids-data-grid-frozen-column-left-width-6);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(7) {
  right: var(--ids-data-grid-frozen-column-left-width-7);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(8) {
  right: var(--ids-data-grid-frozen-column-left-width-8);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(9) {
  right: var(--ids-data-grid-frozen-column-left-width-9);
}
:host([dir=rtl]) .ids-data-grid-cell.frozen-left:nth-of-type(10) {
  right: var(--ids-data-grid-frozen-column-left-width-10);
}
:host([dir=rtl]) .ids-data-grid-cell:last-child {
  border-inline-end-width: var(--ids-border-width-none);
}
:host([dir=rtl]) .ids-data-grid-cell.is-dirty .ids-data-grid-tree-field-container::before, :host([dir=rtl]) .ids-data-grid-cell.is-dirty::before {
  border-color: var(--ids-input-dirty-indicator-color-background-dirty) var(--ids-input-dirty-indicator-color-background-dirty) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.field-indicator-neutral::before {
  border-color: var(--ids-color-accent-neutral-weak) var(--ids-color-accent-neutral-weak) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.field-indicator-info::before {
  border-color: var(--ids-color-info-default) var(--ids-color-info-default) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.field-indicator-success::before {
  border-color: var(--ids-color-success-default) var(--ids-color-success-default) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.field-indicator-caution::before {
  border-color: var(--ids-color-caution-default) var(--ids-color-caution-default) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.field-indicator-warning::before {
  border-color: var(--ids-color-warning-default) var(--ids-color-warning-default) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.field-indicator-error::before {
  border-color: var(--ids-color-error-default) var(--ids-color-error-default) transparent transparent;
}
:host([dir=rtl]) .ids-data-grid-cell.formatter-textmask .is-textmask {
  unicode-bidi: plaintext;
}

.ids-trigger-field-slot-trigger-end {
  margin-inline-end: 2px;
  margin-block-start: 1px;
}

/* stylelint-disable no-invalid-position-declaration */
.hide {
  display: none;
}

@media all and (max-width: 2463px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 2463px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1183px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1183px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 928px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 928px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 927px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 927px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 767px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  :host(.hide-sm-down) {
    display: none;
  }
}

.ids-popup-menu:not([hidden]) {
  display: block;
  z-index: var(--ids-z-index-160);
}

/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
/**
 * Radio Mixins.
 */
:host {
  --ids-data-grid-column-widths: repeat(1, minmax(110px, 1fr));
  font-weight: normal;
  line-height: normal;
  position: relative;
  height: var(--ids-data-grid-height, inherit);
  min-height: var(--ids-data-grid-height-min, auto);
  max-height: var(--ids-data-grid-height-max, none);
}

:host([height]),
:host([max-height]) {
  display: block;
}
:host([height]) .ids-data-grid,
:host([max-height]) .ids-data-grid {
  height: 100%;
  max-height: 100%;
}

.ids-data-grid {
  background-color: var(--ids-data-grid-color-background);
  border: 1px solid var(--ids-data-grid-cell-color-border);
  border-radius: var(--ids-border-radius-2xs);
  border-collapse: collapse;
  box-sizing: border-box;
  overflow: auto;
  outline: none;
  width: var(--ids-data-grid-width, 100%);
  min-width: var(--ids-data-grid-width-min, auto);
  max-width: var(--ids-data-grid-width-max, none);
  display: inline-grid;
  align-content: flex-start;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: var(--ids-font-size-sm);
}
.ids-data-grid .ids-data-grid-checkbox-container {
  cursor: var(--ids-cursor-pointer);
  display: flex;
  width: 100%;
}
.ids-data-grid .ids-data-grid-cell.align-left .ids-data-grid-tree-container,
.ids-data-grid .ids-data-grid-cell.align-left .ids-data-grid-checkbox-container {
  justify-content: start;
}
.ids-data-grid .ids-data-grid-cell.align-center .ids-data-grid-checkbox-container {
  justify-content: center;
}
.ids-data-grid .ids-data-grid-cell.align-right .ids-data-grid-checkbox-container {
  justify-content: end;
}
.ids-data-grid .ids-data-grid-row.no-border-bottom ids-data-grid-cell {
  border-block-end: var(--ids-border-width-none);
}
.ids-data-grid .ids-data-grid-checkbox {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
}
.ids-data-grid .ids-data-grid-checkbox.editable {
  cursor: var(--ids-cursor-pointer);
}
.ids-data-grid .ids-data-grid-checkbox {
  border-color: var(--ids-data-grid-cell-checkbox-color-border);
  position: relative;
  left: var(--ids-space-none);
  top: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-checkbox.disabled {
  background-color: var(--ids-checkbox-color-background-disabled);
  border-color: var(--ids-checkbox-color-border-disabled);
  cursor: var(--ids-cursor-default);
  opacity: 0.4;
}
.ids-data-grid .ids-data-grid-checkbox.checked {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.ids-data-grid .ids-data-grid-checkbox.checked::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s ease-out;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
  animation: none;
}
.ids-data-grid .ids-data-grid-checkbox.checked.disabled {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}
.ids-data-grid .ids-data-grid-checkbox.indeterminate {
  background-color: var(--ids-checkbox-color-background-indeterminate);
  border-color: var(--ids-checkbox-color-border-indeterminate);
}
.ids-data-grid .ids-data-grid-checkbox.indeterminate::after {
  position: absolute;
  animation: checkindeterminate 0.15s ease-out;
  display: block;
  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);
  border-width: var(--ids-checkbox-border-width-indeterminate);
  content: "";
  height: 6px;
  left: 2px;
  top: 0;
  transform: none;
  width: 10px;
  animation: none;
}
.ids-data-grid .ids-data-grid-radio-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
.ids-data-grid .ids-data-grid-radio {
  position: absolute;
  border: 1px solid var(--ids-radio-color-border-default);
  border-radius: var(--ids-radio-border-radius);
  height: 14px;
  left: 0;
  top: 2px;
  transition: all var(--ids-motion-duration) var(--ids-motion-ease);
  width: 14px;
  cursor: var(--ids-cursor-pointer);
  position: relative;
  left: var(--ids-space-none);
  top: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-radio::after {
  position: absolute;
  background-color: var(--ids-radio-color-background);
  border: 1px solid var(--ids-radio-color-background);
  border-radius: var(--ids-radio-border-radius);
  content: "";
  height: 0;
  left: 6px;
  top: 6px;
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), all var(--ids-motion-duration) var(--ids-motion-ease);
  width: 0;
  transform: scale(0);
}
.ids-data-grid .ids-data-grid-radio.disabled {
  border-color: var(--ids-radio-color-border-disabled);
  cursor: var(--ids-cursor-default);
  box-shadow: none;
  opacity: var(--ids-radio-disabled-opacity);
}
.ids-data-grid .ids-data-grid-radio.checked {
  background-color: var(--ids-radio-color-background-selected);
  border-color: var(--ids-radio-color-border-selected);
}
.ids-data-grid .ids-data-grid-radio.checked::after {
  background-color: var(--ids-radio-inner-color-background-selected);
  border-color: var(--ids-radio-inner-color-background-selected);
  border-width: 2px;
  height: 4px;
  left: 3px;
  top: 3px;
  width: 4px;
  transform: scale(1);
}
.ids-data-grid .ids-data-grid-radio.checked.disabled {
  background-color: var(--ids-radio-color-background-selected-disabled);
  border-color: var(--ids-radio-color-border-selected-disabled);
  opacity: var(--ids-radio-disabled-opacity);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container ids-button + .ids-data-grid-tree-field-container .text-ellipsis {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container ids-button {
  padding-inline-start: var(--ids-space-2xs);
  padding-inline-end: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container ids-button.expand-button {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-container .text-ellipsis ids-hyperlink {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid .ids-data-grid-cell .ids-data-grid-tree-field-container {
  display: inline-grid;
  align-items: center;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 1px;
  margin-inline-start: 1px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 1px;
  height: calc(100% - 2px);
  position: absolute;
  width: calc(100% - 2px);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 1px;
  height: calc(100% - 2px);
  position: absolute;
  width: calc(100% - 2px);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  width: calc(100% - 5px);
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -1px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 30px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 54px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 24px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 66px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 36px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 78px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 48px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 90px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 60px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 102px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 72px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 114px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 84px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 126px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 96px;
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xxs] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 3px;
  margin-inline-start: 3px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 1px;
  margin-inline-start: 1px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 2px;
  height: calc(100% - 4px);
  position: absolute;
  width: calc(100% - 4px);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 2px;
  height: calc(100% - 4px);
  position: absolute;
  width: calc(100% - 4px);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  width: calc(100% - 6px);
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -2px;
}
.ids-data-grid[data-row-height=xs] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 32px;
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 55px;
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 23px;
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 68px;
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 36px;
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 81px;
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 49px;
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 94px;
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 62px;
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 107px;
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 75px;
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 120px;
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 88px;
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 133px;
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 101px;
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=xs] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 4px;
  margin-inline-start: 4px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 1px;
  margin-inline-start: 1px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 3px;
  height: calc(100% - 6px);
  position: absolute;
  width: calc(100% - 6px);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 3px;
  height: calc(100% - 6px);
  position: absolute;
  width: calc(100% - 6px);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  width: calc(100% - 9px);
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -5px;
}
.ids-data-grid[data-row-height=sm] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 34px;
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 57px;
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 23px;
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 72px;
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 38px;
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 87px;
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 53px;
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 102px;
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 68px;
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 117px;
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 83px;
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 132px;
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 98px;
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 147px;
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 113px;
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=sm] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 5px;
  margin-inline-start: 5px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 2px;
  margin-inline-start: 2px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  width: calc(100% - 12px);
}
.ids-data-grid[data-row-height=md] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -8px;
}
.ids-data-grid[data-row-height=md] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 40px;
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 60px;
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 20px;
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 77px;
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 37px;
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 94px;
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 54px;
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 111px;
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 71px;
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 128px;
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 88px;
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 145px;
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 105px;
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 162px;
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 122px;
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=md] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-dirty:not(.is-inline).formatter-text::before {
  inset-block-start: 2px;
  margin-inline-start: 2px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-dirty.is-inline.formatter-text::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree) {
  position: relative;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline:not(.formatter-tree)::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  position: relative;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  border: 1px solid var(--ids-input-color-border-default);
  border-radius: var(--ids-border-radius-2xs);
  box-sizing: border-box;
  display: block;
  content: "";
  margin: 4px;
  height: calc(100% - 8px);
  position: absolute;
  width: calc(100% - 8px);
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis {
  width: calc(100% - 16px);
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  margin-inline-end: -12px;
}
.ids-data-grid[data-row-height=lg] .ids-data-grid-tree-field-container .text-ellipsis {
  padding-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 40px;
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell ids-button {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="1"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 60px;
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell ids-button {
  margin-inline-start: 20px;
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="2"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 77px;
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell ids-button {
  margin-inline-start: 37px;
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="3"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 94px;
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell ids-button {
  margin-inline-start: 54px;
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="4"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 111px;
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell ids-button {
  margin-inline-start: 71px;
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="5"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 128px;
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell ids-button {
  margin-inline-start: 88px;
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="6"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 145px;
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell ids-button {
  margin-inline-start: 105px;
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="7"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell .ids-data-grid-tree-field-container {
  margin-inline-start: 162px;
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell ids-button {
  margin-inline-start: 122px;
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell ids-button + .ids-data-grid-tree-field-container {
  margin-inline-start: var(--ids-space-none);
}
.ids-data-grid[data-row-height=lg] [aria-level="8"] .ids-data-grid-cell.is-dirty.is-inline .ids-data-grid-tree-field-container::before {
  inset-block-start: 6px;
  margin-inline-start: 6px;
}
.ids-data-grid[data-row-height=xxs] .ids-data-grid-cell.is-editable.is-inline.formatter-tree .text-ellipsis::after {
  width: calc(100% - 3px);
}
.ids-data-grid.is-list-style {
  border-width: var(--ids-border-width-none);
}
.ids-data-grid.waiting-load {
  visibility: hidden;
  overflow: hidden;
}
.ids-data-grid.waiting-load .ids-data-grid-body {
  visibility: hidden;
}

.ids-data-grid-body {
  display: grid;
  grid-template-columns: var(--ids-data-grid-column-widths);
  min-width: fit-content;
}

table.ids-data-grid {
  display: table;
  outline: 1px solid var(--ids-data-grid-cell-color-border);
  outline-offset: -1px;
}

.ids-data-grid-wrapper {
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  position: relative;
}
.ids-data-grid-wrapper.has-empty-message {
  height: var(--ids-data-grid-height, var(--ids-data-grid-height-min));
  min-height: var(--ids-data-grid-height-min);
}
.ids-data-grid-wrapper .ids-data-grid-toolbar {
  display: flex;
  width: 100%;
  margin: 6px var(--ids-space-none);
  align-items: center;
  justify-content: end;
}

ids-empty-message:not([hidden]),
::slotted(ids-empty-message:not([hidden])) {
  display: flex;
  width: 100%;
  position: absolute;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  top: 45%;
  left: 50%;
  translate: -50% -35%;
}

ids-empty-message.has-filter-row:not([hidden]):not([icon]):not(.has-pager) {
  translate: -50% 20%;
}

::slotted(ids-empty-message.has-filter-row:not(.has-pager):not([icon]):not([hidden])) {
  translate: -50% 20%;
}

.has-empty-message .ids-data-grid {
  min-height: var(--ids-data-grid-height-min);
}

.has-empty-message.in-constrained-container {
  overflow: hidden;
}
.has-empty-message.in-constrained-container .ids-data-grid {
  min-height: min(var(--ids-data-grid-height-min), 100%);
}

.has-loading-indicator .ids-data-grid {
  min-height: var(--ids-data-grid-height-min);
}

ids-loading-indicator {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: var(--ids-space-none);
}
ids-loading-indicator[stopped] {
  display: none;
}
ids-loading-indicator.ids-data-grid-loading {
  top: 50px;
  min-height: 350px;
}

:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected):not(.activated) ids-data-grid-cell,
:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected):not(.activated) ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {
  background-color: var(--ids-data-grid-row-color-background-hover);
}
:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected):not(.activated) ids-data-grid-cell.is-invalid {
  background-color: var(--ids-data-grid-cell-color-background-error-hover);
}
:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*=row-]):not(.selected):not(.activated) .ids-data-grid-cell.frozen {
  background-color: var(--ids-data-grid-row-color-background-hover);
}

#datagrid-modal {
  --ids-modal-content-padding: var(--ids-space-none);
  --ids-modal-header-padding: var(--ids-space-sm) var(--ids-space-sm) var(--ids-space-xs) var(--ids-space-sm);
  --ids-popup-fit-height: 400px;
}
#datagrid-modal ids-swappable-item {
  --ids-swappable-item-color-background-selected: var(--ids-color-accent-blue-weakest);
  --ids-swappable-item-color-text-selected: var(--ids-color-foreground-default-default);
  align-items: center;
  height: var(--ids-data-grid-modal-row-height);
}
#datagrid-modal #datagrid-modal-title {
  position: relative;
  top: calc(var(--ids-space-04) * -1);
}
#datagrid-modal ids-search-field {
  --ids-input-color-background-default: var(--ids-color-accent-neutral-weakest);
  --ids-search-field-color-background-default: var(--ids-color-accent-neutral-weakest);
  --ids-input-color-border-default: var(--ids-color-accent-neutral-weak);
  --ids-input-color-border-hover: var(--ids-color-accent-neutral-weak);
  --ids-input-color-border-focus: var(--ids-color-accent-neutral-weak);
  --ids-input-color-border-shadow: none;
  --ids-search-field-border-radius: var(--ids-border-radius-none);
  --ids-search-field-border-width: var(--ids-border-width-sm) var(--ids-border-width-none);
  margin-bottom: -8px;
  margin-top: calc(var(--ids-space-08) * -1);
  min-width: 330px;
  position: sticky;
  top: var(--ids-space-none);
  z-index: 1;
}
#datagrid-modal ids-text {
  width: 100%;
}
#datagrid-modal ids-switch {
  position: relative;
  top: var(--ids-space-3xs);
}
#datagrid-modal ids-swappable {
  width: 100%;
}
#datagrid-modal .datagrid-modal-column-list {
  --ids-modal-column-list-height: calc(100% - 14px);
  overflow: auto;
  max-height: var(--ids-modal-column-list-height);
}

.selection-border {
  position: absolute;
  pointer-events: none;
  border: 1.5px solid var(--ids-button-primary-color-background-default);
  background: transparent;
  z-index: 2;
  transition: all 0.05s ease;
}

.row-drag-container {
  background-color: var(--ids-data-grid-row-color-background-selected);
  display: grid;
  grid-template-columns: var(--ids-data-grid-column-widths);
  opacity: 0.8;
  overflow: hidden;
  position: absolute;
  top: -1000px;
}

.row-drag-cell {
  align-items: center;
  background-color: var(--ids-data-grid-row-color-background-selected);
  border: 1px solid var(--ids-data-grid-cell-color-border);
  display: grid;
  height: 50px;
}

.required-text {
  color: var(--ids-tooltip-color-text);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-data-grid/ids-data-grid-filters.scss","webpack://./src/components/ids-data-grid/ids-data-grid.scss","webpack://./src/components/ids-data-grid/ids-data-grid-header.scss","webpack://./src/components/ids-data-grid/ids-data-grid-row.scss","webpack://./src/components/ids-data-grid/ids-data-grid-cell.scss","webpack://./src/themes/mixins/ids-hide-mixin.scss","webpack://./src/components/ids-popup-menu/ids-popup-menu.scss","webpack://./src/themes/mixins/ids-checkbox-mixin.scss","webpack://./src/themes/mixins/ids-radio-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/components/ids-data-grid/ids-data-grid-common.scss"],"names":[],"mappings":"AAAA,qCAAA;AACA;EACE;;GAAA;EAGA;;GAAA;EAGA;;GAAA;EAGA,gCAAA;EACA,gDAAA;ACCF;ADCE;EACE,mDAAA;EAEA,gBAAA;ACAJ;ADGE;EAIE,cAAA;ACJJ;ADOE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;ACLJ;ADQE;EACE,kBAAA;EACA,oCAAA;ACNJ;ADSE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,+CAAA;EACA,sCAAA;ACPJ;ADSI;EACE,aAAA;ACPN;ADUI;EACE,aAAA;ACRN;ADWI;EACE,gBAAA;EACA,8BAAA;ACTN;ADcE;EACE,aAAA;ACZJ;ADiBM;;;EAGE,yBAAA;ACfR;ADoBE;EACE,sCAAA;EACA,qCAAA;EAEA,sBAAA;EACA,sBAAA;ACnBJ;ADqBI;EACE,wBAAA;EACA,uBAAA;ACnBN;ADsBI;EACE,uBAAA;ACpBN;;ACnEA,qCAAA;AACA;EACE,gBAAA;EACA,aAAA;EACA,yDAAA;EACA,0BAAA;EACA,UAAA;EACA,YAAA;ADsEF;ACpEE;EACE,UAAA;ADsEJ;ACnEE;EACE,YAAA;ADqEJ;ACnEI;EACE,YAAA;ADqEN;ACrFA;EAqBE,iCAAA;ADmEF;;AC/DA;EACE,WAAA;ADkEF;AChEE;EACE,eAAA;ADkEJ;AC/DE;EACE,oBAAA;EACA,8DAAA;ADiEJ;AC9DE;EACE,uEAAA;ADgEJ;AC9DI;EACE,+DAAA;ADgEN;AC5DE;EACE,oDAAA;EACA,gCAAA;EACA,aAAA;AD8DJ;;ACzDA;EACE,sBAAA;EACA,uEAAA;EACA,oEAAA;EACA,sEAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AD4DF;AC1DE;EACE,YAAA;AD4DJ;AC1DI;EACE,YAAA;AD4DN;ACzDI;EACE,uCAAA;AD2DN;ACxDI;EACE,0CAAA;AD0DN;ACxDM;EACE,0CAAA;AD0DR;ACxDQ;EACE,eAAA;AD0DV;ACtDM;;;EAGE,0CAAA;ADwDR;ACnDE;EACE,aAAA;ADqDJ;ACjDE;EACE,uDAAA;ADmDJ;AChDE;EACE,oEAAA;ADkDJ;AC/CE;EACE,gDAAA;EACA,oBAAA;EACA,UAAA;ADiDJ;AC7CE;EACE,aAAA;AD+CJ;AC3CE;EACE,aAAA;AD6CJ;AC1CE;EAEE,uBAAA;AD2CJ;ACxCE;EAEE,yBAAA;ADyCJ;ACtCE;EACE,mDAAA;EACA,yBAAA;ADwCJ;ACpCI;EACE,yCAAA;ADsCN;ACjCE;EACE,gCAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,0BAAA;EACA,UAAA;EACA,UAAA;ADmCJ;ACjCI;EACE,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,iEAAA;EACA,0CAAA;EACA,iCAAA;EACA,UAAA;ADmCN;ACjCM;EACE,wBAAA;EACA,uBAAA;ADmCR;AC9BI;EACE,2EAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;ADgCN;AC3BE;EACE,8BAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;AD6BJ;AC3BI;EACE,kBAAA;EACA,6CAAA;EACA,kDAAA;EACA,kBAAA;EACA,oBAAA;AD6BN;ACzBE;EACE,qBAAA;EACA,2BAAA;AD2BJ;ACxBE;EACE,qCAAA;AD0BJ;ACvBE;EACE,8EAAA;EAIA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;ADsBJ;ACnBE;EACE,2FAAA;ADqBJ;ACjBI;EACE,UAAA;ADmBN;ACfE;EACE,UAAA;ADiBJ;ACbE;EACE,sEAAA;EACA,gBAAA;EACA,UAAA;ADeJ;ACXE;EACE,qEAAA;ADaJ;ACXI;EACE,uDAAA;ADaN;ACTE;EACE,gBAAA;EACA,2BAAA;EACA,UAAA;ADWJ;ACPM;EACE,qDAAA;ADSR;ACVM;EACE,qDAAA;ADYR;ACbM;EACE,qDAAA;ADeR;AChBM;EACE,qDAAA;ADkBR;ACnBM;EACE,qDAAA;ADqBR;ACtBM;EACE,qDAAA;ADwBR;ACzBM;EACE,qDAAA;AD2BR;AC5BM;EACE,qDAAA;AD8BR;AC/BM;EACE,sDAAA;ADiCR;AC5BE;EACE,gBAAA;EACA,4BAAA;AD8BJ;AC3BI;EACE,oBAAA;AD6BN;;ACvBA;EACE,sDAAA;EACA,oBAAA;AD0BF;;ACvBA;EACE,aAAA;AD0BF;;ACvBA;EACE,cAAA;EACA,+CAAA;EACA,4CAAA;EACA,4CAAA;EACA,6CAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AD0BF;ACxBE;EACE,0CAAA;EACA,4CAAA;AD0BJ;;ACtBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ADyBF;;ACpBE;;EAEE,YAAA;EACA,6DAAA;EACA,yCAAA;ADuBJ;;ACnBA;EACE,kBAAA;EACA,6CAAA;EACA,yCAAA;EACA,wCAAA;ADsBF;;AClBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,WAAA;ADqBF;;AChBE;EACE,sDAAA;EACA,UAAA;EACA,kDAAA;ADmBJ;ACjBI;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;ADmBN;AChBI;EACE,kBAAA;EACA,UAAA;ADkBN;ACdE;EACE,eAAA;ADgBJ;ACdI;EACE,UAAA;ADgBN;;ACXA;EACE,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,iDAAA;EACA,wCAAA;ADcF;ACZE;EACE,wDAAA;ADcJ;;ACVA;EACE,yBAAA;ADaF;;ACVA;;EAEE,cAAA;ADaF;;ACVA;EACE,2CAAA;EACA,yCAAA;ADaF;;ACRE;;EACE,yCAAA;ADYJ;;ACNE;EACE,oDAAA;EACA,UAAA;ADSJ;ACNE;EACE,UAAA;ADQJ;;ACFE;EACE,UAAA;ADKJ;ACFE;EACE,oDAAA;EACA,UAAA;ADIJ;;ACCA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ADEF;ACAE;EAEE,kCAAA;EACA,mCAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;ADCJ;ACEE;EACE,6EAAA;EAEA,SAAA;ADDJ;ACIE;EACE,gFAAA;EAEA,YAAA;ADHJ;;ACQA;EACE,kBAAA;EACA,iBAAA;ADLF;;ACQA;EACE,mBAAA;ADLF;;ACWE;EACE,mEAAA;EACA,2DAAA;ADRJ;ACWE;EACE,kDAAA;ADTJ;ACcI;EACE,sDAAA;ADZN;ACgBE;;EAEE,2DAAA;ADdJ;ACmBI;EACE,wEAAA;ADjBN;;ACuBA;EACE,sBAAA;ADpBF;;AC0BI;EACE,+CAAA;ADvBN;AC0BI;EACE,yBAAA;ADxBN;AC2BI;EACE,qBAAA;ADzBN;AC4BI;EAEE,uCAAA;AD3BN;ACgCI;EACE,+CAAA;AD9BN;ACiCI;EACE,aAAA;AD/BN;ACkCI;EACE,yBAAA;ADhCN;ACoCM;EACE,uCAAA;ADlCR;ACqCM;EACE,mCAAA;ADnCR;ACyCI;EACE,YAAA;ADvCN;ACyCM;EACE,YAAA;ADvCR;AC0CM;EACE,YAAA;ADxCR;AC4CI;EACE,gBAAA;AD1CN;AC4CM;EACE,YAAA;AD1CR;AC8CI;EAIE,YAAA;AD/CN;ACkDI;EAGE,YAAA;ADlDN;ACoDM;EACE,uCAAA;ADlDR;ACqDM;EACE,oCAAA;EACA,sBAAA;ADnDR;ACuDI;EACE,+CAAA;ADrDN;ACwDI;EACE,aAAA;ADtDN;ACyDI;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;ADvDN;AC0DI;EACE,iCAAA;ADxDN;AC2DI;EAGE,mDAAA;EACA,yBAAA;AD3DN;ACgEI;EACE,YAAA;AD9DN;ACgEM;EACE,YAAA;AD9DR;ACiEM;EACE,YAAA;AD/DR;ACkEM;EACE,YAAA;ADhER;ACoEI;EACE,gBAAA;ADlEN;ACoEM;EACE,YAAA;ADlER;ACsEI;EAIE,YAAA;ADvEN;AC0EI;EAGE,YAAA;AD1EN;AC4EM;EACE,6BAAA;EACA,wBAAA;AD1ER;AC6EM;EACE,oCAAA;EACA,sBAAA;AD3ER;AC+EI;EACE,gDAAA;AD7EN;ACgFI;EACE,aAAA;AD9EN;ACiFI;EACE,0CAAA;EACA,wBAAA;EACA,YAAA;AD/EN;ACiFM;EACE,QAAA;AD/ER;ACkFM;EACE,UAAA;ADhFR;ACoFI;EACE,0CAAA;ADlFN;ACqFI;EACE,gBAAA;ADnFN;ACsFI;EAGE,uBAAA;EACA,yBAAA;ADtFN;AC0FI;;;;EAIE,2BAAA;ADxFN;AC2FI;EACE,uDAAA;ADzFN;AC4FI;EACE,kEAAA;EACA,gEAAA;EACA,+DAAA;AD1FN;;ACiGE;EAEE,2BAAA;AD/FJ;ACiGI;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;AD/FN;ACoGM;EACE,UAAA;ADlGR;ACuGM;EACE,UAAA;ADrGR;AC0GE;EACE,yBAAA;ADxGJ;;ACgHI;EACE,cAAA;AD7GN;ACgHI;EACE,qDAAA;AD9GN;ACiHI;EACE,gBAAA;EACA,4BAAA;AD/GN;ACmHQ;EACE,sDAAA;ADjHV;ACgHQ;EACE,sDAAA;AD9GV;AC6GQ;EACE,sDAAA;AD3GV;AC0GQ;EACE,sDAAA;ADxGV;ACuGQ;EACE,sDAAA;ADrGV;ACoGQ;EACE,sDAAA;ADlGV;ACiGQ;EACE,sDAAA;AD/FV;AC8FQ;EACE,sDAAA;AD5FV;AC2FQ;EACE,uDAAA;ADzFV;;AExqBA,mCAAA;AACA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AF2qBF;AExqBE;EACE,YAAA;EACA,8CAAA;EACA,gDAAA;EACA,mBAAA;AF0qBJ;AEvqBE;EAGE,oEAAA;EACA,6DAAA;AFuqBJ;AErqBI;EAEE,2CAAA;AFsqBN;AElqBE;EACE,oEAAA;AFoqBJ;AEhqBE;EACE,aAAA;AFkqBJ;AE7pBI;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;AF+pBN;AEzpBM;EACE,yHAAA;AF2pBR;AE7pBI;EAKE,+DAAA;EACA,0DAAA;AF2pBN;AErpBM;EACE,iIAAA;AFupBR;AEzpBI;EAKE,mEAAA;EACA,0DAAA;AFupBN;AEjpBM;EACE,6HAAA;AFmpBR;AErpBI;EAKE,iEAAA;EACA,0DAAA;AFmpBN;AE7oBM;EACE,iIAAA;AF+oBR;AEjpBI;EAKE,mEAAA;EACA,0DAAA;AF+oBN;AE1oBE;EACE,gFAAA;AF4oBJ;;AEtoBE;EACE,mEAAA;EACA,kDAAA;EACA,8DAAA;EACA,sBAAA;EACA,iBAAA;AFyoBJ;AEtoBE;EACE,yDAAA;EACA,qDAAA;EAEA,cAAA;AFuoBJ;;AE/nBI;EACE,0CAAA;AFkoBN;AEhoBM;;EAEE,qDAAA;EACA,mDAAA;AFkoBR;AE9nBI;EACE,8CAAA;EACA,gDAAA;EACA,YAAA;AFgoBN;AE7nBI;EACE,qDAAA;EACA,qEAAA;AF+nBN;AE5nBI;EACE,qDAAA;AF8nBN;AEznBI;EACE,0CAAA;AF2nBN;AEznBM;;EAEE,qDAAA;EACA,mDAAA;AF2nBR;AEvnBI;EACE,8CAAA;EACA,YAAA;AFynBN;AEvnBM;EACE,wCAAA;EACA,gDAAA;AFynBR;AErnBI;EACE,qDAAA;EACA,qEAAA;AFunBN;AEpnBI;EACE,qDAAA;AFsnBN;AEjnBI;EACE,0CAAA;EACA,4CAAA;AFmnBN;AEjnBM;;EAEE,qDAAA;EACA,mDAAA;AFmnBR;AE/mBI;EACE,8CAAA;EACA,YAAA;AFinBN;AE/mBM;EACE,wCAAA;EACA,gDAAA;AFinBR;AE7mBI;EACE,qDAAA;EACA,qEAAA;AF+mBN;AE5mBI;EACE,qDAAA;AF8mBN;AEzmBI;EACE,2CAAA;EACA,4CAAA;AF2mBN;AEzmBM;;EAEE,sDAAA;EACA,oDAAA;AF2mBR;AErmBQ;EACE,qDAAA;EACA,mDAAA;AFumBV;AElmBI;EACE,+CAAA;EACA,YAAA;AFomBN;AElmBM;EACE,yCAAA;EACA,iDAAA;AFomBR;AEhmBI;EACE,sDAAA;EACA,qEAAA;AFkmBN;AE/lBI;EACE,sDAAA;AFimBN;AE7lBE;EACE,sCAAA;AF+lBJ;AE7lBI;EACE,wDAAA;AF+lBN;;AEzlBA;EACE,uEAAA;AF4lBF;;AExlBA;EACE,+DAAA;EACA,gFAAA;EACA,iBAAA;EACA,4BAAA;AF2lBF;;AEvlBA;EACE,kBAAA;EACA,0CAAA;AF0lBF;;AEplBK;EACC,qDAAA;AFulBN;AErlBM;EACE,4DAAA;EACA,kBAAA;EACA,UAAA;AFulBR;AEplBM;EACE,0DAAA;AFslBR;AEjlBE;EACE,gBAAA;EACA,aAAA;AFmlBJ;AE/kBE;;EAEE,0BAAA;AFilBJ;;AEzkBQ;EACI,yHAAA;AF4kBZ;AErkBQ;EACI,iIAAA;AFukBZ;AEhkBQ;EACI,iIAAA;AFkkBZ;AE1jBQ;EACI,6HAAA;AF4jBZ;;AG94BA,oCAAA;AAGA,8DAAA;AAeA,gEAAA;AAYA;EACE,mBAAA;AHs3BF;;AGn3BA;EACE,mBAAA;AHs3BF;;AGn3BA;EACE,mBAAA;AHs3BF;;AGn3BA;EACE,mBAAA;AHs3BF;;AGj3BI;EACE,uDAAA;AHo3BN;AGj3BI;EACE,uDAAA;AHm3BN;;AG92BA;EAEE,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;EACA,oDAAA;EACA,oBAAA;EACA,mDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AHg3BF;AG72BE;EACE,uDAAA;AH+2BJ;AG32BE;EACE,uCAAA;EACA,wCAAA;AH62BJ;AG12BE;EACE,yCAAA;EACA,uCAAA;AH42BJ;AGx2BE;EACE,0CAAA;AH02BJ;AGv2BE;EACE,SAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;EACA,6BAAA;EACA,qBAAA;AHy2BJ;AGp2BI;EACE,WAAA;EACA,qBAAA;EACA,eAAA;AHs2BN;AGl2BE;EACE,qBAAA;EACA,sBAAA;EACA,qDAAA;EACA,mDAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AHo2BJ;AGj2BE;EACE,aAAA;AHm2BJ;AGh2BE;EACE,qBAAA;EACA,sBAAA;EACA,wCAAA;EACA,mBAAA;AHk2BJ;AG/1BE;EACE,YAAA;EACA,8CAAA;EACA,uBAAA;EACA,qBAAA;EACA,uDAAA;EACA,qBAAA;AHi2BJ;AG71BE;EACE,sBAAA;AH+1BJ;AG71BI;EACE,sBAAA;EACA,iBAAA;EACA,oCAAA;AH+1BN;AG11BE;EACE,oDAAA;EACA,uCAAA;AH41BJ;AGz1BE;EACE,qBAAA;EACA,WAAA;EACA,uCAAA;AH21BJ;AGt1BI;EACE,oBAAA;EACA,kCAAA;AHw1BN;AGn1BI;EACE,yBAAA;EACA,wCAAA;AHq1BN;AGl1BI;EACE,iBAAA;AHo1BN;AG/0BE;EACE,4EAAA;AHi1BJ;AG70BI;EACE,aAAA;AH+0BN;AG30BE;EACE,oDAAA;AH60BJ;AG30BI;EACE,aAAA;AH60BN;AGz0BE;EACE,yBAAA;AH20BJ;AGp0BI;EACE,gCAAA;EACA,aAAA;EACA,+CAAA;EACA,UAAA;AHs0BN;AGj0BM;EACE,UAAA;AHm0BR;AG7zBI;EACE,8BAAA;AH+zBN;AG7zBM;EACE,uCAAA;AH+zBR;AG3zBI;EACE,uBAAA;EACA,wCAAA;EACA,aAAA;AH6zBN;AG3zBM;EACE,oBAAA;AH6zBR;AG3zBQ;EACE,eAAA;AH6zBV;AGtzBM;EACE,aAAA;AHwzBR;AGrzBM;EACE,uCAAA;AHuzBR;AGpzBM;EACE,gCAAA;AHszBR;AG/yBM;EACE,qEAAA;AHizBR;AG3yBQ;EACE,YAAA;EACA,WAAA;AH6yBV;AG1yBQ;EACE,YAAA;EACA,WAAA;AH4yBV;AGzyBQ;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AH2yBV;AGxyBQ;EACE,uBAAA;AH0yBV;AGtyBM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AHwyBR;AGtyBQ;EACE,uBAAA;AHwyBV;AGnyBI;EAGE,8BAAA;AHmyBN;AGjyBM;EACE,yCAAA;AHmyBR;AG7xBM;EACE,yBAAA;EACA,uBAAA;AH+xBR;AG1xBM;EACE,SAAA;EACA,aAAA;EACA,WAAA;AH4xBR;AGzxBM;;EAEE,8CAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;AH2xBR;AGvxBI;EACE,sBAAA;EACA,wCAAA;EACA,aAAA;AHyxBN;AGvxBM;EACE,oBAAA;AHyxBR;AGvxBQ;EACE,eAAA;AHyxBV;AGpxBI;EACE,cAAA;AHsxBN;AGhxBM;EACE,aAAA;AHkxBR;AG/wBM;EACE,gCAAA;AHixBR;AG7wBI;EACE,8BAAA;AH+wBN;AG7wBM;EACE,oBAAA;AH+wBR;AG5wBM;EACE,sBAAA;AH8wBR;AGzwBE;EACE,mCAAA;EACA,yEAAA;EACA,6DAAA;AH2wBJ;AGzwBI;EACE;;GAAA;AH6wBN;AGnxBE;EAWE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AH2wBJ;AGvwBE;EAIE,iBAAA;AHswBJ;AGnwBE;EACE,WAAA;AHqwBJ;AGhwBI;EACE,WAAA;AHkwBN;AG/vBI;EACE,4BAAA;AHiwBN;AG3vBI;EACE,WAAA;AH6vBN;AG1vBI;EACE,4BAAA;AH4vBN;AGvvBE;EACE,gBAAA;AHyvBJ;AGvvBI;EACE,+BAAA;AHyvBN;AGpvBE;EACE,gBAAA;AHsvBJ;AGlvBE;EACE,mBAAA;AHovBJ;AGjvBE;EACE,mBAAA;AHmvBJ;AGhvBE;EACE,gBAAA;AHkvBJ;AG/uBE;EACE,qBAAA;AHivBJ;AG9uBE;EACE,qBAAA;AHgvBJ;AG7uBE;EACE,yBAAA;AH+uBJ;AG5uBE;EACE,aAAA;AH8uBJ;AG3uBE;EACE,YAAA;AH6uBJ;AGzuBE;EACE,yBAAA;AH2uBJ;AGzuBI;;;EAGE,yBAAA;AH2uBN;AGtuBE;EACE,gBAAA;EACA,uDAAA;EACA,UAAA;AHwuBJ;AGpuBE;EACE,mEAAA;AHsuBJ;AGpuBI;EACE,yBAAA;AHsuBN;AGnuBI;EACE,yBAAA;AHquBN;AGjuBE;EACE,gBAAA;EACA,2BAAA;AHmuBJ;AG/tBM;EACE,qDAAA;AHiuBR;AGluBM;EACE,qDAAA;AHouBR;AGruBM;EACE,qDAAA;AHuuBR;AGxuBM;EACE,qDAAA;AH0uBR;AG3uBM;EACE,qDAAA;AH6uBR;AG9uBM;EACE,qDAAA;AHgvBR;AGjvBM;EACE,qDAAA;AHmvBR;AGpvBM;EACE,qDAAA;AHsvBR;AGvvBM;EACE,sDAAA;AHyvBR;AGpvBE;EACE,gBAAA;EACA,4BAAA;AHsvBJ;AGnvBE;EAphBA,qJAAA;EAGA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;AHwwCF;AGzvBE;EA1gBA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;AHswCF;AG/vBE;EACE,+GAAA;AHiwBJ;AG5vBE;EACE,iGAAA;AH8vBJ;AGzvBE;EACE,uGAAA;AH2vBJ;AGtvBE;EACE,uGAAA;AHwvBJ;AGnvBE;EACE,uGAAA;AHqvBJ;AGhvBE;EACE,mGAAA;AHkvBJ;AG7uBE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,QAAA;EACA,2BAAA;AH+uBJ;AG3uBE;EACE,2CAAA;AH6uBJ;AG1uBE;EACE,oCAAA;AH4uBJ;AGzuBE;EACE,uCAAA;AH2uBJ;AGxuBE;EACE,uCAAA;AH0uBJ;AGvuBE;EACE,uCAAA;AHyuBJ;AGtuBE;EACE,qCAAA;AHwuBJ;AGnuBI;EACE,oDAAA;AHquBN;AGhuBE;EACE,aAAA;AHkuBJ;AG7tBM;EACE,aAAA;EACA,aAAA;AH+tBR;AG5tBM;EACE,kBAAA;AH8tBR;AG5tBQ;EA1nBN,qJAAA;EAGA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uCAAA;EACA,UAAA;AHu1CF;AGjuBI;EACE,kBAAA;EACA,sBAAA;AHmuBN;AG/tBM;EACE,0CAAA;EACA,yCAAA;AHiuBR;AG5tBE;EACE,sBAAA;EACA,kBAAA;AH8tBJ;AG3tBE;EACE,kEAAA;AH6tBJ;AG1tBM;EACE,aAAA;AH4tBR;AGvtBE;EACE,oEAAA;AHytBJ;AGttBE;EACE,eAAA;AHwtBJ;AGrtBE;EACE,8BAAA;AHutBJ;AGptBE;EACE,gDAAA;AHstBJ;AG9rBU;EACE,uBAAA;EACA,uBAAA;AHgsBZ;AGlsBU;EACE,sBAAA;EACA,uBAAA;AHosBZ;AGtsBU;EACE,uBAAA;EACA,uBAAA;AHwsBZ;AG1sBU;EACE,sBAAA;EACA,uBAAA;AH4sBZ;;AG/rBI;EACE,wCAAA;AHksBN;AG9rBE;EACE,iBAAA;EACA,sBAAA;EACA,wBAAA;AHgsBJ;AG7rBE;EACE,kBAAA;EACA,QAAA;AH+rBJ;AG5rBE;EACE,+CAAA;AH8rBJ;AG3rBE;EACE;;GAAA;AH+rBJ;AG1rBE;EACE,iEAAA;AH4rBJ;AGzrBE;;EAEE,kBAAA;EACA,2DAAA;AH2rBJ;AGvrBI;EACE,0CAAA;EACA,yCAAA;AHyrBN;AGtrBI;EACE,wCAAA;AHwrBN;AGnrBI;EACE,8CAAA;AHqrBN;AGhrBE;EACE,uCAAA;AHkrBJ;AG9qBE;EACE,uCAAA;AHgrBJ;AG7qBE;EACE,0EAAA;AH+qBJ;AG5qBE;EACE,mDAAA;EAEA,2DAAA;AH6qBJ;AGzqBI;EACE,gDAAA;AH2qBN;AGxqBI;EACE,uCAAA;AH0qBN;AGvqBI;EACE,oCAAA;AHyqBN;;AG9pBI;EACE,uCAAA;AHiqBN;AG7pBE;EACE,iBAAA;AH+pBJ;AG5pBE;EACE,kBAAA;EACA,QAAA;AH8pBJ;AG3pBE;EACE,8BAAA;AH6pBJ;AG1pBE;EACE;;GAAA;AH8pBJ;AGzpBE;EACE,iEAAA;AH2pBJ;AGxpBE;EACE,2DAAA;AH0pBJ;AGxpBI;EACE,0CAAA;EACA,yCAAA;AH0pBN;AGrpBE;EACE,uCAAA;AHupBJ;AGnpBE;EACE,uCAAA;AHqpBJ;AGlpBE;EACE,0EAAA;EACA,2DAAA;AHopBJ;AGjpBE;EACE,mDAAA;AHmpBJ;AG/oBI;EACE,+CAAA;AHipBN;AG9oBI;EACE,oCAAA;AHgpBN;;AGroBI;EACE,uCAAA;AHwoBN;AGpoBE;EACE,+CAAA;AHsoBJ;AGloBE;EACE,sBAAA;AHooBJ;AGhoBE;EACE,sBAAA;EACA,qBAAA;AHkoBJ;AG/nBE;EACE,0EAAA;AHioBJ;AG7nBI;EACE,+CAAA;AH+nBN;AG5nBI;EACE,mCAAA;AH8nBN;;AGnnBI;EACE,uCAAA;AHsnBN;AGjnBE;EACE,sBAAA;AHmnBJ;AGhnBE;EACE,kDAAA;AHknBJ;AG/mBE;EACE,0EAAA;AHinBJ;AG/mBI;EACE,kBAAA;EACA,UAAA;AHinBN;AG5mBI;EACE,+CAAA;AH8mBN;;AGnmBI;EACE,+CAAA;AHsmBN;;AG9lBE;EACE,0CAAA;EACA,oEAAA;AHimBJ;AG/lBI;EACE,qEAAA;AHimBN;AG9lBI;EACE,oDAAA;AHgmBN;AG7lBI;EACE,8BAAA;AH+lBN;AG3lBE;EACE,aAAA;AH6lBJ;;AGxlBA;EACE,mBAAA;EACA,yCAAA;EACA,uCAAA;AH2lBF;;AGrlBI;EACE,qDAAA;AHwlBN;AGllBI;EACE,gBAAA;EACA,4BAAA;AHolBN;AGhlBQ;EACE,sDAAA;AHklBV;AGnlBQ;EACE,sDAAA;AHqlBV;AGtlBQ;EACE,sDAAA;AHwlBV;AGzlBQ;EACE,sDAAA;AH2lBV;AG5lBQ;EACE,sDAAA;AH8lBV;AG/lBQ;EACE,sDAAA;AHimBV;AGlmBQ;EACE,sDAAA;AHomBV;AGrmBQ;EACE,sDAAA;AHumBV;AGxmBQ;EACE,uDAAA;AH0mBV;AGrmBI;EACE,qDAAA;AHumBN;AGnmBM;EAEE,qJAAA;AHomBR;AG9lBI;EACE,+GAAA;AHgmBN;AG3lBI;EACE,iGAAA;AH6lBN;AGxlBI;EACE,uGAAA;AH0lBN;AGrlBI;EACE,uGAAA;AHulBN;AGllBI;EACE,uGAAA;AHolBN;AG/kBI;EACE,mGAAA;AHilBN;AG3kBM;EACE,uBAAA;AH6kBR;;AGtkBA;EACE,sBAAA;EACA,uBAAA;AHykBF;;AI1oDA,sDAAA;AAIA;EACE,aAAA;AJ0oDF;;AItoDE;EADF;IAEI,aAAA;EJ0oDF;AACF;;AIhoDE;EADF;IAEI,aAAA;EJooDF;AACF;;AI1nDE;EADF;IAEI,aAAA;EJ8nDF;AACF;;AIpnDE;EADF;IAEI,aAAA;EJwnDF;AACF;;AI9mDE;EADF;IAEI,aAAA;EJknDF;AACF;;AIxmDE;EADF;IAEI,aAAA;EJ4mDF;AACF;;AIlmDE;EADF;IAEI,aAAA;EJsmDF;AACF;;AI5lDE;EADF;IAEI,aAAA;EJgmDF;AACF;;AItlDE;EADF;IAEI,aAAA;EJ0lDF;AACF;;AIhlDE;EADF;IAEI,aAAA;EJolDF;AACF;;AI1kDE;EADF;IAEI,aAAA;EJ8kDF;AACF;;AIpkDE;EADF;IAEI,aAAA;EJwkDF;AACF;;AIxmDE;EC7GF;ID8GI,aAAA;EJ4mDF;AACF;;AKttDE;EACE,cAAA;EACA,+BAAA;ALytDJ;;AMluDA;;EAAA;AAoIA;EACE;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,QAAA;ENomDF;EMjmDA;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,UAAA;ENmmDF;EMhmDA;IACE,YAAA;IACA,SAAA;IACA,MAAA;IACA,UAAA;ENkmDF;AACF;AM/lDA;EACE;IACE,QAAA;ENimDF;EM9lDA;IACE,WAAA;ENgmDF;AACF;AOlwDA;;EAAA;APWA;EACE,4DAAA;EAEA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,iDAAA;EACA,iDAAA;AA2vDF;;AAvvDA;;EAEE,cAAA;AA0vDF;AAxvDE;;EACE,YAAA;EACA,gBAAA;AA2vDJ;;AAvvDA;EAEE,uDAAA;EACA,wDAAA;EACA,2CAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EAGA,oBAAA;EACA,yBAAA;EQtCA,mCAAA;EACA,kCAAA;ER0CA,+EAAA;EACA,kCAAA;AAqvDF;AAlvDE;EACE,iCAAA;EACA,aAAA;EACA,WAAA;AAovDJ;AA/uDI;;EAEE,sBAAA;AAivDN;AA5uDI;EACE,uBAAA;AA8uDN;AAzuDI;EACE,oBAAA;AA2uDN;AAvuDE;EACE,8CAAA;AAyuDJ;AAtuDE;EM/EA,kBAAA;EACA,kCAAA;EACA,gDAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;ANwzDF;AA5uDI;EACE,iCAAA;AA8uDN;AAlvDE;EAOE,6DAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AA8uDJ;AA5uDI;EMpCF,+DAAA;EACA,uDAAA;EACA,iCAAA;ENqCI,YAAA;AA+uDN;AA5uDI;EMlFF,+DAAA;EACA,uDAAA;ANi0DF;AA7uDM;EMhFJ,kBAAA;EACA,cAAA;EACA,sFAAA;EACA,6DAAA;EACA,+BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;ENyEM,eAAA;AAwvDR;AArvDM;EMzCJ,wEAAA;EACA,gEAAA;ANiyDF;AApvDI;EM5EF,oEAAA;EACA,4DAAA;ANm0DF;AArvDM;EM1EJ,kBAAA;EACA,4CAAA;EACA,cAAA;EACA,sEAAA;EACA,4DAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;ENmEM,eAAA;AAgwDR;AA1vDE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AA4vDJ;AAzvDE;EOjIA,kBAAA;EACA,uDAAA;EACA,6CAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,iEAAA;EACA,WAAA;EP6HE,iCAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AAiwDJ;AA/vDI;EO9HF,kBAAA;EACA,mDAAA;EACA,mDAAA;EACA,6CAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,yHAAA;EACA,QAAA;EACA,mBAAA;APg4DF;AAxwDI;EO1FF,oDAAA;EACA,iCAAA;EACA,gBAAA;EACA,0CAAA;APq2DF;AA1wDI;EO/GF,4DAAA;EACA,oDAAA;AP43DF;AA3wDM;EO7GJ,kEAAA;EACA,8DAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;AP23DF;AAjxDM;EOtFJ,qEAAA;EACA,6DAAA;EACA,0CAAA;AP02DF;AA/wDE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAixDJ;AA/wDI;EACE,0CAAA;AAixDN;AA9wDI;EACE,0CAAA;EACA,yCAAA;AAgxDN;AA7wDI;EACE,0EAAA;EACA,sEAAA;EACA,4EAAA;EACA,wEAAA;AA+wDN;AA3wDM;EACE,0CAAA;AA6wDR;AAxwDE;EACE,oBAAA;EACA,mBAAA;AA0wDJ;AA3rDc;EACE,sBAAA;EACA,wBAAA;AA6rDhB;AAtrDc;EACE,sBAAA;EACA,wBAAA;AAwrDhB;AAhrDU;ESnSR,kBAAA;ATs9DF;ASp9DE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATs9DJ;AAzrDY;ESxSV,kBAAA;ATo+DF;ASl+DE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATo+DJ;AAvsDY;EAGE,uBAAA;AAusDd;AArsDc;EACE,uBAAA;AAusDhB;AA/rDM;EACE,2CAAA;AAisDR;AAzrDY;EACE,yBAAA;AA2rDd;AAxrDY;EACE,0CAAA;AA0rDd;AAvrDY;EACE,0CAAA;AAyrDd;AArqDc;EACE,sBAAA;EACA,wBAAA;AAuqDhB;AA1rDY;EACE,yBAAA;AA4rDd;AAzrDY;EACE,yBAAA;AA2rDd;AAxrDY;EACE,0CAAA;AA0rDd;AAlrDc;EACE,sBAAA;EACA,wBAAA;AAorDhB;AAvsDY;EACE,yBAAA;AAysDd;AAtsDY;EACE,yBAAA;AAwsDd;AArsDY;EACE,0CAAA;AAusDd;AA/rDc;EACE,sBAAA;EACA,wBAAA;AAisDhB;AAptDY;EACE,yBAAA;AAstDd;AAntDY;EACE,yBAAA;AAqtDd;AAltDY;EACE,0CAAA;AAotDd;AA5sDc;EACE,sBAAA;EACA,wBAAA;AA8sDhB;AAjuDY;EACE,yBAAA;AAmuDd;AAhuDY;EACE,yBAAA;AAkuDd;AA/tDY;EACE,0CAAA;AAiuDd;AAztDc;EACE,sBAAA;EACA,wBAAA;AA2tDhB;AA9uDY;EACE,0BAAA;AAgvDd;AA7uDY;EACE,yBAAA;AA+uDd;AA5uDY;EACE,0CAAA;AA8uDd;AAtuDc;EACE,sBAAA;EACA,wBAAA;AAwuDhB;AA3vDY;EACE,0BAAA;AA6vDd;AA1vDY;EACE,yBAAA;AA4vDd;AAzvDY;EACE,0CAAA;AA2vDd;AAnvDc;EACE,sBAAA;EACA,wBAAA;AAqvDhB;AAxwDY;EACE,0BAAA;AA0wDd;AAvwDY;EACE,yBAAA;AAywDd;AAtwDY;EACE,0CAAA;AAwwDd;AAhwDc;EACE,sBAAA;EACA,wBAAA;AAkwDhB;AAh1Dc;EACE,sBAAA;EACA,wBAAA;AAk1DhB;AA30Dc;EACE,sBAAA;EACA,wBAAA;AA60DhB;AAr0DU;ESnSR,kBAAA;AT2mEF;ASzmEE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT2mEJ;AA90DY;ESxSV,kBAAA;ATynEF;ASvnEE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATynEJ;AA51DY;EAGE,uBAAA;AA41Dd;AA11Dc;EACE,uBAAA;AA41DhB;AAp1DM;EACE,2CAAA;AAs1DR;AA90DY;EACE,yBAAA;AAg1Dd;AA70DY;EACE,0CAAA;AA+0Dd;AA50DY;EACE,0CAAA;AA80Dd;AA1zDc;EACE,sBAAA;EACA,wBAAA;AA4zDhB;AA/0DY;EACE,yBAAA;AAi1Dd;AA90DY;EACE,yBAAA;AAg1Dd;AA70DY;EACE,0CAAA;AA+0Dd;AAv0Dc;EACE,sBAAA;EACA,wBAAA;AAy0DhB;AA51DY;EACE,yBAAA;AA81Dd;AA31DY;EACE,yBAAA;AA61Dd;AA11DY;EACE,0CAAA;AA41Dd;AAp1Dc;EACE,sBAAA;EACA,wBAAA;AAs1DhB;AAz2DY;EACE,yBAAA;AA22Dd;AAx2DY;EACE,yBAAA;AA02Dd;AAv2DY;EACE,0CAAA;AAy2Dd;AAj2Dc;EACE,sBAAA;EACA,wBAAA;AAm2DhB;AAt3DY;EACE,yBAAA;AAw3Dd;AAr3DY;EACE,yBAAA;AAu3Dd;AAp3DY;EACE,0CAAA;AAs3Dd;AA92Dc;EACE,sBAAA;EACA,wBAAA;AAg3DhB;AAn4DY;EACE,0BAAA;AAq4Dd;AAl4DY;EACE,yBAAA;AAo4Dd;AAj4DY;EACE,0CAAA;AAm4Dd;AA33Dc;EACE,sBAAA;EACA,wBAAA;AA63DhB;AAh5DY;EACE,0BAAA;AAk5Dd;AA/4DY;EACE,yBAAA;AAi5Dd;AA94DY;EACE,0CAAA;AAg5Dd;AAx4Dc;EACE,sBAAA;EACA,wBAAA;AA04DhB;AA75DY;EACE,0BAAA;AA+5Dd;AA55DY;EACE,0BAAA;AA85Dd;AA35DY;EACE,0CAAA;AA65Dd;AAr5Dc;EACE,sBAAA;EACA,wBAAA;AAu5DhB;AAr+Dc;EACE,sBAAA;EACA,wBAAA;AAu+DhB;AAh+Dc;EACE,sBAAA;EACA,wBAAA;AAk+DhB;AA19DU;ESnSR,kBAAA;ATgwEF;AS9vEE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATgwEJ;AAn+DY;ESxSV,kBAAA;AT8wEF;AS5wEE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT8wEJ;AAj/DY;EAGE,uBAAA;AAi/Dd;AA/+Dc;EACE,uBAAA;AAi/DhB;AAz+DM;EACE,2CAAA;AA2+DR;AAn+DY;EACE,yBAAA;AAq+Dd;AAl+DY;EACE,0CAAA;AAo+Dd;AAj+DY;EACE,0CAAA;AAm+Dd;AA/8Dc;EACE,sBAAA;EACA,wBAAA;AAi9DhB;AAp+DY;EACE,yBAAA;AAs+Dd;AAn+DY;EACE,yBAAA;AAq+Dd;AAl+DY;EACE,0CAAA;AAo+Dd;AA59Dc;EACE,sBAAA;EACA,wBAAA;AA89DhB;AAj/DY;EACE,yBAAA;AAm/Dd;AAh/DY;EACE,yBAAA;AAk/Dd;AA/+DY;EACE,0CAAA;AAi/Dd;AAz+Dc;EACE,sBAAA;EACA,wBAAA;AA2+DhB;AA9/DY;EACE,yBAAA;AAggEd;AA7/DY;EACE,yBAAA;AA+/Dd;AA5/DY;EACE,0CAAA;AA8/Dd;AAt/Dc;EACE,sBAAA;EACA,wBAAA;AAw/DhB;AA3gEY;EACE,0BAAA;AA6gEd;AA1gEY;EACE,yBAAA;AA4gEd;AAzgEY;EACE,0CAAA;AA2gEd;AAngEc;EACE,sBAAA;EACA,wBAAA;AAqgEhB;AAxhEY;EACE,0BAAA;AA0hEd;AAvhEY;EACE,yBAAA;AAyhEd;AAthEY;EACE,0CAAA;AAwhEd;AAhhEc;EACE,sBAAA;EACA,wBAAA;AAkhEhB;AAriEY;EACE,0BAAA;AAuiEd;AApiEY;EACE,yBAAA;AAsiEd;AAniEY;EACE,0CAAA;AAqiEd;AA7hEc;EACE,sBAAA;EACA,wBAAA;AA+hEhB;AAljEY;EACE,0BAAA;AAojEd;AAjjEY;EACE,0BAAA;AAmjEd;AAhjEY;EACE,0CAAA;AAkjEd;AA1iEc;EACE,sBAAA;EACA,wBAAA;AA4iEhB;AA1nEc;EACE,sBAAA;EACA,wBAAA;AA4nEhB;AArnEc;EACE,sBAAA;EACA,wBAAA;AAunEhB;AA/mEU;ESnSR,kBAAA;ATq5EF;ASn5EE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATq5EJ;AAxnEY;ESxSV,kBAAA;ATm6EF;ASj6EE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATm6EJ;AAtoEY;EAGE,wBAAA;AAsoEd;AApoEc;EACE,uBAAA;AAsoEhB;AA9nEM;EACE,2CAAA;AAgoER;AAxnEY;EACE,yBAAA;AA0nEd;AAvnEY;EACE,0CAAA;AAynEd;AAtnEY;EACE,0CAAA;AAwnEd;AApmEc;EACE,sBAAA;EACA,wBAAA;AAsmEhB;AAznEY;EACE,yBAAA;AA2nEd;AAxnEY;EACE,yBAAA;AA0nEd;AAvnEY;EACE,0CAAA;AAynEd;AAjnEc;EACE,sBAAA;EACA,wBAAA;AAmnEhB;AAtoEY;EACE,yBAAA;AAwoEd;AAroEY;EACE,yBAAA;AAuoEd;AApoEY;EACE,0CAAA;AAsoEd;AA9nEc;EACE,sBAAA;EACA,wBAAA;AAgoEhB;AAnpEY;EACE,yBAAA;AAqpEd;AAlpEY;EACE,yBAAA;AAopEd;AAjpEY;EACE,0CAAA;AAmpEd;AA3oEc;EACE,sBAAA;EACA,wBAAA;AA6oEhB;AAhqEY;EACE,0BAAA;AAkqEd;AA/pEY;EACE,yBAAA;AAiqEd;AA9pEY;EACE,0CAAA;AAgqEd;AAxpEc;EACE,sBAAA;EACA,wBAAA;AA0pEhB;AA7qEY;EACE,0BAAA;AA+qEd;AA5qEY;EACE,yBAAA;AA8qEd;AA3qEY;EACE,0CAAA;AA6qEd;AArqEc;EACE,sBAAA;EACA,wBAAA;AAuqEhB;AA1rEY;EACE,0BAAA;AA4rEd;AAzrEY;EACE,0BAAA;AA2rEd;AAxrEY;EACE,0CAAA;AA0rEd;AAlrEc;EACE,sBAAA;EACA,wBAAA;AAorEhB;AAvsEY;EACE,0BAAA;AAysEd;AAtsEY;EACE,0BAAA;AAwsEd;AArsEY;EACE,0CAAA;AAusEd;AA/rEc;EACE,sBAAA;EACA,wBAAA;AAisEhB;AA/wEc;EACE,sBAAA;EACA,wBAAA;AAixEhB;AA1wEc;EACE,sBAAA;EACA,wBAAA;AA4wEhB;AApwEU;ESnSR,kBAAA;AT0iFF;ASxiFE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AT0iFJ;AA7wEY;ESxSV,kBAAA;ATwjFF;AStjFE;EACE,uDAAA;EACA,2CAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;ATwjFJ;AA3xEY;EAGE,wBAAA;AA2xEd;AAzxEc;EACE,wBAAA;AA2xEhB;AAnxEM;EACE,2CAAA;AAqxER;AA7wEY;EACE,yBAAA;AA+wEd;AA5wEY;EACE,0CAAA;AA8wEd;AA3wEY;EACE,0CAAA;AA6wEd;AAzvEc;EACE,sBAAA;EACA,wBAAA;AA2vEhB;AA9wEY;EACE,yBAAA;AAgxEd;AA7wEY;EACE,yBAAA;AA+wEd;AA5wEY;EACE,0CAAA;AA8wEd;AAtwEc;EACE,sBAAA;EACA,wBAAA;AAwwEhB;AA3xEY;EACE,yBAAA;AA6xEd;AA1xEY;EACE,yBAAA;AA4xEd;AAzxEY;EACE,0CAAA;AA2xEd;AAnxEc;EACE,sBAAA;EACA,wBAAA;AAqxEhB;AAxyEY;EACE,yBAAA;AA0yEd;AAvyEY;EACE,yBAAA;AAyyEd;AAtyEY;EACE,0CAAA;AAwyEd;AAhyEc;EACE,sBAAA;EACA,wBAAA;AAkyEhB;AArzEY;EACE,0BAAA;AAuzEd;AApzEY;EACE,yBAAA;AAszEd;AAnzEY;EACE,0CAAA;AAqzEd;AA7yEc;EACE,sBAAA;EACA,wBAAA;AA+yEhB;AAl0EY;EACE,0BAAA;AAo0Ed;AAj0EY;EACE,yBAAA;AAm0Ed;AAh0EY;EACE,0CAAA;AAk0Ed;AA1zEc;EACE,sBAAA;EACA,wBAAA;AA4zEhB;AA/0EY;EACE,0BAAA;AAi1Ed;AA90EY;EACE,0BAAA;AAg1Ed;AA70EY;EACE,0CAAA;AA+0Ed;AAv0Ec;EACE,sBAAA;EACA,wBAAA;AAy0EhB;AA51EY;EACE,0BAAA;AA81Ed;AA31EY;EACE,0BAAA;AA61Ed;AA11EY;EACE,0CAAA;AA41Ed;AAp1Ec;EACE,sBAAA;EACA,wBAAA;AAs1EhB;AA10EM;EACE,uBAAA;AA40ER;AAt0EE;EACE,0CAAA;AAw0EJ;AAp0EE;EACE,kBAAA;EACA,gBAAA;AAs0EJ;AAp0EI;EACE,kBAAA;AAs0EN;;AAh0EA;EACE,aAAA;EACA,yDAAA;EACA,sBAAA;AAm0EF;;AA/zEA;EACE,cAAA;EACA,yDAAA;EACA,oBAAA;AAk0EF;;AA9zEA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAi0EF;AA/zEE;EACE,oEAAA;EACA,2CAAA;AAi0EJ;AA9zEE;EACE,aAAA;EACA,WAAA;EACA,iCAAA;EACA,mBAAA;EACA,oBAAA;AAg0EJ;;AA5zEA;;EAEE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AA+zEF;;AA1zEE;EACE,mBAAA;AA6zEJ;;AAzzEA;EACE,mBAAA;AA4zEF;;AAzzEA;EACE,2CAAA;AA4zEF;;AAzzEA;EACE,gBAAA;AA4zEF;AA1zEE;EACE,sDAAA;AA4zEJ;;AAxzEA;EACE,2CAAA;AA2zEF;;AAvzEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AA0zEF;AAxzEE;EACE,aAAA;AA0zEJ;AAvzEE;EACE,SAAA;EACA,iBAAA;AAyzEJ;;AApzEE;;EAEE,iEAAA;AAuzEJ;AApzEE;EACE,wEAAA;AAszEJ;AAnzEE;EACE,iEAAA;AAqzEJ;;AAjzEA;EACE,kDAAA;EACA,2GAAA;EACA,6BAAA;AAozEF;AAlzEE;EACE,oFAAA;EACA,qFAAA;EAEA,mBAAA;EACA,6CAAA;AAmzEJ;AAhzEE;EACE,kBAAA;EACA,mCAAA;AAkzEJ;AA/yEE;EACE,6EAAA;EACA,oFAAA;EACA,sEAAA;EACA,oEAAA;EACA,oEAAA;EACA,qCAAA;EACA,+DAAA;EACA,wFAAA;EAEA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,UAAA;AAgzEJ;AA7yEE;EACE,WAAA;AA+yEJ;AA5yEE;EACE,kBAAA;EACA,yBAAA;AA8yEJ;AA3yEE;EACE,WAAA;AA6yEJ;AA1yEE;EACE,iDAAA;EAEA,cAAA;EACA,+CAAA;AA2yEJ;;AAtyEA;EACE,kBAAA;EACA,oBAAA;EACA,sEAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;AAyyEF;;AAryEA;EACE,oEAAA;EACA,aAAA;EACA,yDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAwyEF;;AAryEA;EACE,mBAAA;EACA,oEAAA;EACA,wDAAA;EACA,aAAA;EACA,YAAA;AAwyEF;;AAryEA;EACE,oCAAA;AAwyEF","sourcesContent":["/* Ids Data Grid Component - Filter */\n.ids-data-grid {\n  --ids-button-formatter-color-text-default: var(\n    --ids-data-grid-filter-icon-color\n  );\n  --ids-button-formatter-color-background-hover: var(\n    --ids-data-grid-filter-icon-color-background-hover\n  );\n  --ids-button-formatter-color-text-hover: var(\n    --ids-data-grid-filter-icon-color-hover\n  );\n  --ids-menu-item-width-min: 190px;\n  --ids-trigger-field-button-inset-inline-start: 0;\n\n  .ids-data-grid-header-cell-filter-wrapper ids-dropdown {\n    --ids-trigger-field-button-inset-inline-start: -1px;\n\n    padding-top: 3px;\n  }\n\n  &[data-row-height='md'] ids-dropdown,\n  &[data-row-height='sm'] ids-dropdown,\n  &[data-row-height='xs'] ids-dropdown,\n  &[data-row-height='xxs'] ids-dropdown {\n    padding-top: 0;\n  }\n\n  ::slotted([slot^='filter-']) {\n    align-items: center;\n    display: flex;\n    position: relative;\n  }\n\n  .ids-data-grid-header-cell-content.vertical-align-center {\n    position: relative;\n    top: calc(50% - var(--ids-space-sm));\n  }\n\n  .ids-data-grid-header-cell-filter-wrapper {\n    align-items: center;\n    display: flex;\n    position: relative;\n    padding-inline: calc(var(--ids-space-xs) + 4px);\n    padding-block-end: var(--ids-space-xs);\n\n    &.hidden {\n      display: none;\n    }\n\n    &[hidden] {\n      display: none;\n    }\n\n    ids-dropdown[compact] ids-list-box-option {\n      font-size: unset;\n      min-height: var(--ids-size-20);\n    }\n  }\n\n  // Hide filter wrappers when header doesn't have has-filter class\n  .ids-data-grid-header:not(.has-filter) .ids-data-grid-header-cell-filter-wrapper {\n    display: none;\n  }\n\n  .ids-data-grid-header-cell.is-uppercase {\n    .ids-data-grid-header-cell-filter-wrapper {\n      ids-list-box-option,\n      ids-dropdown::part(triggerfield-input),\n      ids-input::part(input) {\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  [data-filter-conditions-button] {\n    --ids-button-icon-compact-height: 20px;\n    --ids-button-icon-compact-width: 36px;\n\n    margin-inline-end: 2px;\n    margin-inline-start: 0;\n\n    ids-icon {\n      margin-inline-start: 3px;\n      margin-inline-end: -3px;\n    }\n\n    ids-icon-button {\n      padding-inline-start: 0;\n    }\n  }\n}\n","@use 'sass:map';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n@use './ids-data-grid-common' as *;\n@use './ids-data-grid-filters' as *;\n@use './ids-data-grid-header' as *;\n@use './ids-data-grid-row' as *;\n@use './ids-data-grid-cell' as *;\n@use '../../components/ids-popup-menu/ids-popup-menu' as *;\n@use '../../themes/mixins/ids-checkbox-mixin' as *;\n@use '../../themes/mixins/ids-radio-mixin' as *;\n\n:host {\n  --ids-data-grid-column-widths: repeat(1, minmax(110px, 1fr));\n\n  font-weight: normal;\n  line-height: normal;\n  position: relative;\n  height: var(--ids-data-grid-height, inherit);\n  min-height: var(--ids-data-grid-height-min, auto);\n  max-height: var(--ids-data-grid-height-max, none);\n}\n\n// Apply block display when any height constraint is set\n:host([height]),\n:host([max-height]) {\n  display: block;\n\n  .ids-data-grid {\n    height: 100%;\n    max-height: 100%;\n  }\n}\n\n.ids-data-grid {\n  // Outside border and Background and sizing\n  background-color: var(--ids-data-grid-color-background);\n  border: 1px solid var(--ids-data-grid-cell-color-border);\n  border-radius: var(--ids-border-radius-2xs);\n  border-collapse: collapse;\n  box-sizing: border-box;\n  overflow: auto;\n  outline: none;\n  width: var(--ids-data-grid-width, 100%);\n  min-width: var(--ids-data-grid-width-min, auto);\n  max-width: var(--ids-data-grid-width-max, none);\n\n  // Needed so sticky header works in safari\n  display: inline-grid;\n  align-content: flex-start;\n\n  // Font Info\n  @include mixins.antialiased();\n\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: var(--ids-font-size-sm);\n\n  // Selection Checkbox\n  .ids-data-grid-checkbox-container {\n    cursor: var(--ids-cursor-pointer);\n    display: flex;\n    width: 100%;\n  }\n\n  // Checkbox alignments\n  .ids-data-grid-cell.align-left {\n    .ids-data-grid-tree-container,\n    .ids-data-grid-checkbox-container {\n      justify-content: start;\n    }\n  }\n\n  .ids-data-grid-cell.align-center {\n    .ids-data-grid-checkbox-container {\n      justify-content: center;\n    }\n  }\n\n  .ids-data-grid-cell.align-right {\n    .ids-data-grid-checkbox-container {\n      justify-content: end;\n    }\n  }\n\n  .ids-data-grid-row.no-border-bottom ids-data-grid-cell {\n    border-block-end: var(--ids-border-width-none);\n  }\n\n  .ids-data-grid-checkbox {\n    @include checkbox-unchecked();\n\n    &.editable {\n      cursor: var(--ids-cursor-pointer);\n    }\n\n    border-color: var(--ids-data-grid-cell-checkbox-color-border);\n    position: relative;\n    left: var(--ids-space-none);\n    top: var(--ids-space-none);\n\n    &.disabled {\n      @include checkbox-disabled-unchecked();\n\n      opacity: 0.4;\n    }\n\n    &.checked {\n      @include checkbox-checked();\n\n      &::after {\n        @include checkbox-checked-after();\n\n        animation: none;\n      }\n\n      &.disabled {\n        @include checkbox-disabled-checked();\n      }\n    }\n\n    &.indeterminate {\n      @include checkbox-indeterminate();\n\n      &::after {\n        @include checkbox-indeterminate-after();\n\n        animation: none;\n      }\n    }\n  }\n\n  // Selection Radio\n  .ids-data-grid-radio-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .ids-data-grid-radio {\n    @include radio-unchecked();\n\n    cursor: var(--ids-cursor-pointer);\n    position: relative;\n    left: var(--ids-space-none);\n    top: var(--ids-space-none);\n\n    &::after {\n      @include radio-unchecked-after();\n    }\n\n    &.disabled {\n      @include radio-disabled-unchecked();\n    }\n\n    &.checked {\n      @include radio-checked();\n\n      &::after {\n        @include radio-checked-after();\n      }\n\n      &.disabled {\n        @include radio-disabled-checked();\n      }\n    }\n  }\n\n  // Tree Grid\n  .ids-data-grid-cell .ids-data-grid-tree-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    ids-button + .ids-data-grid-tree-field-container .text-ellipsis {\n      margin-inline-start: var(--ids-space-none);\n    }\n\n    ids-button {\n      padding-inline-start: var(--ids-space-2xs);\n      padding-inline-end: var(--ids-space-none);\n    }\n\n    ids-button.expand-button {\n      --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n      --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);\n      --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);\n      --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);\n    }\n\n    .text-ellipsis {\n      ids-hyperlink {\n        margin-inline-start: var(--ids-space-none);\n      }\n    }\n  }\n\n  .ids-data-grid-cell .ids-data-grid-tree-field-container {\n    display: inline-grid;\n    align-items: center;\n  }\n\n  // =======================================================\n  // Maps used for altering alignments of editable grid cells in different scenarios.\n  // These rules are based on row-height, which is defined at the `.ids-data-grid` element level.\n  // =======================================================\n  $row-height-inline-tree-grid-button-widths: (\n    'xxs': 30,\n    'xs': 32,\n    'sm': 34,\n    'md': 40,\n    'lg': 40\n  );\n\n  $row-height-padding-offsets: (\n    'xxs': 12,\n    'xs': 10,\n    'sm': 8,\n    'md': 3,\n    'lg': 3\n  );\n\n  $row-height-dirty-indicator-offsets: (\n    'xxs': 1,\n    'xs': 1,\n    'sm': 1,\n    'md': 2,\n    'lg': 2\n  );\n\n  $row-height-inline-dirty-indicator-offsets: (\n    'xxs': 3,\n    'xs': 4,\n    'sm': 5,\n    'md': 6,\n    'lg': 6\n  );\n\n  $row-height-indents: (\n    'xxs': 12,\n    'xs': 13,\n    'sm': 15,\n    'md': 17,\n    'lg': 17\n  );\n\n  $row-height-outline-padding: (\n    'xxs': 1,\n    'xs': 2,\n    'sm': 3,\n    'md': 4,\n    'lg': 4\n  );\n\n  $row-height-outline-offsets: (\n    'xxs': 1,\n    'xs': 2,\n    'sm': 5,\n    'md': 8,\n    'lg': 12\n  );\n\n  @each $rowHeight, $offset in $row-height-padding-offsets {\n    // These values are different for each Row Height\n    $button-width: map.get($row-height-inline-tree-grid-button-widths, $rowHeight);\n    $indent: map.get($row-height-indents, $rowHeight);\n    $dirty-indicator-offset: map.get($row-height-dirty-indicator-offsets, $rowHeight);\n    $inline-dirty-indicator-offset: map.get($row-height-inline-dirty-indicator-offsets, $rowHeight);\n    $outline-offset: map.get($row-height-outline-offsets, $rowHeight);\n    $outline-padding: map.get($row-height-outline-padding, $rowHeight);\n\n    &[data-row-height='#{$rowHeight}'] {\n      // ================================================\n      // Top-level grid alignments that depend solely on row height\n      .ids-data-grid-cell {\n        &.is-dirty {\n          &:not(.is-inline) {\n            &.formatter-text {\n              &::before {\n                inset-block-start: #{$dirty-indicator-offset}px;\n                margin-inline-start: #{$dirty-indicator-offset}px;\n              }\n            }\n          }\n\n          &.is-inline {\n            &.formatter-text {\n              &::before {\n                inset-block-start: #{$inline-dirty-indicator-offset}px;\n                margin-inline-start: #{$inline-dirty-indicator-offset}px;\n              }\n            }\n          }\n        }\n\n        // Defines the position of the inline-edit style's outline\n        &.is-editable.is-inline {\n          &:not(.formatter-tree) {\n            @include ids-data-grid-inline-editable-outline($outline-padding);\n          }\n\n          &.formatter-tree {\n            .text-ellipsis {\n              @include ids-data-grid-inline-editable-outline($outline-padding);\n\n              width: calc(100% - #{$outline-offset + 4}px);\n\n              &::after {\n                margin-inline-end: -#{$outline-offset}px;\n              }\n            }\n          }\n        }\n      }\n\n      // Remove start padding from tree-grid-contained `.text-ellipsis` elements\n      .ids-data-grid-tree-field-container .text-ellipsis {\n        padding-inline-start: var(--ids-space-none);\n      }\n\n      // ================================================\n      // Expandable grid/tree grid nested alignment rules\n      @for $i from 1 through 8 {\n        [aria-level='#{$i}'] .ids-data-grid-cell {\n          @if $i == 1 {\n            .ids-data-grid-tree-field-container {\n              margin-inline-start: #{$button-width}px;\n            }\n\n            ids-button {\n              margin-inline-start: var(--ids-space-none);\n            }\n\n            ids-button + .ids-data-grid-tree-field-container {\n              margin-inline-start: var(--ids-space-none);\n            }\n          } @else {\n            .ids-data-grid-tree-field-container {\n              margin-inline-start: #{$button-width + ($indent * ($i - 1)) + ($offset)}px;\n            }\n\n            ids-button {\n              margin-inline-start: #{($indent * ($i - 1)) + $offset}px;\n            }\n\n            ids-button + .ids-data-grid-tree-field-container {\n              margin-inline-start: var(--ids-space-none);\n            }\n          }\n\n          // ================================================\n          // Dirty-tracker rules dependent on `aria-level` nesting\n          &.is-dirty {\n            &.is-inline {\n              .ids-data-grid-tree-field-container::before {\n                inset-block-start: #{$inline-dirty-indicator-offset}px;\n                margin-inline-start: #{$inline-dirty-indicator-offset}px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Fix for xxs row height tree formatter cells with expand icons\n  &[data-row-height='xxs'] {\n    .ids-data-grid-cell.is-editable.is-inline.formatter-tree {\n      .text-ellipsis::after {\n        width: calc(100% - 3px);\n      }\n    }\n  }\n\n  // List Style Feature\n  &.is-list-style {\n    border-width: var(--ids-border-width-none);\n  }\n\n  // Used for row start\n  &.waiting-load {\n    visibility: hidden;\n    overflow: hidden;\n\n    .ids-data-grid-body {\n      visibility: hidden;\n    }\n  }\n}\n\n// Used for Frozen Columns\n.ids-data-grid-body {\n  display: grid;\n  grid-template-columns: var(--ids-data-grid-column-widths);\n  min-width: fit-content;\n}\n\n// Standalone Css Borders\ntable.ids-data-grid {\n  display: table;\n  outline: 1px solid var(--ids-data-grid-cell-color-border);\n  outline-offset: -1px;\n}\n\n// Empty Message\n.ids-data-grid-wrapper {\n  height: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  position: relative;\n\n  &.has-empty-message {\n    height: var(--ids-data-grid-height, var(--ids-data-grid-height-min));\n    min-height: var(--ids-data-grid-height-min);\n  }\n\n  .ids-data-grid-toolbar {\n    display: flex;\n    width: 100%;\n    margin: 6px var(--ids-space-none);\n    align-items: center;\n    justify-content: end;\n  }\n}\n\nids-empty-message:not([hidden]),\n::slotted(ids-empty-message:not([hidden])) {\n  display: flex;\n  width: 100%;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n  top: 45%;\n  left: 50%;\n  translate: -50% -35%;\n}\n\n\nids-empty-message.has-filter-row:not([hidden]) {\n  &:not([icon]):not(.has-pager) {\n    translate: -50% 20%;\n  }\n}\n\n::slotted(ids-empty-message.has-filter-row:not(.has-pager):not([icon]):not([hidden])) {\n  translate: -50% 20%;\n}\n\n.has-empty-message .ids-data-grid {\n  min-height: var(--ids-data-grid-height-min);\n}\n\n.has-empty-message.in-constrained-container {\n  overflow: hidden;\n\n  .ids-data-grid {\n    min-height: min(var(--ids-data-grid-height-min), 100%);\n  }\n}\n\n.has-loading-indicator .ids-data-grid {\n  min-height: var(--ids-data-grid-height-min);\n}\n\n// Loading Indicator\nids-loading-indicator {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  top: var(--ids-space-none);\n\n  &[stopped] {\n    display: none;\n  }\n\n  &.ids-data-grid-loading {\n    top: 50px;\n    min-height: 350px;\n  }\n}\n\n:host(:not([disable-row-highlight])) ids-data-grid-row:hover:not([part*='row-']):not(.selected):not(.activated) {\n  ids-data-grid-cell,\n  ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {\n    background-color: var(--ids-data-grid-row-color-background-hover);\n  }\n\n  ids-data-grid-cell.is-invalid {\n    background-color: var(--ids-data-grid-cell-color-background-error-hover);\n  }\n\n  .ids-data-grid-cell.frozen {\n    background-color: var(--ids-data-grid-row-color-background-hover);\n  }\n}\n\n#datagrid-modal {\n  --ids-modal-content-padding: var(--ids-space-none);\n  --ids-modal-header-padding: var(--ids-space-sm) var(--ids-space-sm) var(--ids-space-xs) var(--ids-space-sm);\n  --ids-popup-fit-height: 400px;\n\n  ids-swappable-item {\n    --ids-swappable-item-color-background-selected: var(--ids-color-accent-blue-weakest);\n    --ids-swappable-item-color-text-selected: var(--ids-color-foreground-default-default);\n\n    align-items: center;\n    height: var(--ids-data-grid-modal-row-height);\n  }\n\n  #datagrid-modal-title {\n    position: relative;\n    top: calc(var(--ids-space-04) * -1);\n  }\n\n  ids-search-field {\n    --ids-input-color-background-default: var(--ids-color-accent-neutral-weakest);\n    --ids-search-field-color-background-default: var(--ids-color-accent-neutral-weakest);\n    --ids-input-color-border-default: var(--ids-color-accent-neutral-weak);\n    --ids-input-color-border-hover: var(--ids-color-accent-neutral-weak);\n    --ids-input-color-border-focus: var(--ids-color-accent-neutral-weak);\n    --ids-input-color-border-shadow: none;\n    --ids-search-field-border-radius: var(--ids-border-radius-none);\n    --ids-search-field-border-width: var(--ids-border-width-sm) var(--ids-border-width-none);\n\n    margin-bottom: -8px;\n    margin-top: calc(var(--ids-space-08) * -1);\n    min-width: 330px;\n    position: sticky;\n    top: var(--ids-space-none);\n    z-index: 1;\n  }\n\n  ids-text {\n    width: 100%;\n  }\n\n  ids-switch {\n    position: relative;\n    top: var(--ids-space-3xs);\n  }\n\n  ids-swappable {\n    width: 100%;\n  }\n\n  .datagrid-modal-column-list {\n    --ids-modal-column-list-height: calc(100% - 14px);\n\n    overflow: auto;\n    max-height: var(--ids-modal-column-list-height);\n  }\n\n}\n\n.selection-border {\n  position: absolute;\n  pointer-events: none;\n  border: 1.5px solid var(--ids-button-primary-color-background-default);\n  background: transparent;\n  z-index: 2;\n  transition: all 0.05s ease;\n}\n\n// Row Reordering\n.row-drag-container {\n  background-color: var(--ids-data-grid-row-color-background-selected);\n  display: grid;\n  grid-template-columns: var(--ids-data-grid-column-widths);\n  opacity: 0.8;\n  overflow: hidden;\n  position: absolute;\n  top: -1000px;\n}\n\n.row-drag-cell {\n  align-items: center;\n  background-color: var(--ids-data-grid-row-color-background-selected);\n  border: 1px solid var(--ids-data-grid-cell-color-border);\n  display: grid;\n  height: 50px;\n}\n\n.required-text {\n  color: var(--ids-tooltip-color-text);\n}\n","/* Ids Data Grid Component - Header */\n.ids-data-grid-header {\n  position: sticky;\n  display: grid;\n  grid-template-columns: var(--ids-data-grid-column-widths);\n  top: var(--ids-space-none);\n  z-index: 5; // Must be higher than focused body cells (z-index: 3)\n  height: 34px;\n\n  &.is-frozen {\n    z-index: 5;\n  }\n\n  &.has-filter:has(.ids-data-grid-header-cell-filter-wrapper) {\n    height: 62px;\n\n    &:has(br) {\n      height: 78px;\n    }\n  }\n\n  // Filter button height\n  --ids-button-formatter-size: 28px;\n}\n\n// Header Checkbox\n.ids-data-grid-header-text .ids-data-grid-checkbox-container {\n  width: 20px;\n\n  &[disabled='true'] {\n    cursor: default;\n  }\n\n  .ids-data-grid-checkbox[disabled='true'] {\n    pointer-events: none;\n    opacity: var(--ids-data-grid-header-checkbox-opacity-disabled);\n  }\n\n  .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {\n    background-color: var(--ids-data-grid-header-checkbox-color-background);\n\n    &:not(:focus) {\n      border-color: var(--ids-data-grid-header-checkbox-color-border);\n    }\n  }\n\n  .ids-data-grid-checkbox:focus {\n    border-color: var(--ids-checkbox-color-border-focus);\n    box-shadow: var(--ids-shadow-20);\n    outline: none;\n  }\n}\n\n// Header Cell Area\n.ids-data-grid-header-cell {\n  box-sizing: border-box;\n  border-inline-start: 1px solid var(--ids-data-grid-header-color-border);\n  border-block-end: 1px solid var(--ids-data-grid-header-color-border);\n  background-color: var(--ids-data-grid-header-color-background-default);\n  min-height: 28px;\n  position: relative;\n  user-select: text;\n\n  .has-filter &:has(.ids-data-grid-header-cell-filter-wrapper) {\n    height: 62px;\n\n    &:has(br) {\n      height: 78px;\n    }\n\n    .ids-data-grid-header-text {\n      padding-block-end: var(--ids-space-2xs);\n    }\n\n    .ids-data-grid-header-cell-filter-wrapper {\n      height: var(--ids-data-grid-filter-height);\n\n      ids-menu-button {\n        height: var(--ids-data-grid-filter-height);\n\n        &::part(button) {\n          height: inherit;\n        }\n      }\n\n      ids-dropdown::part(triggerfield-field-container),\n      ids-input::part(field-container),\n      ids-trigger-field::part(field-container) {\n        height: var(--ids-data-grid-filter-height);\n      }\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n\n  // Hide first border\n  &:first-child {\n    border-inline-start-width: var(--ids-border-width-none);\n  }\n\n  &:hover.is-actionable {\n    background-color: var(--ids-data-grid-header-color-background-hover);\n  }\n\n  &:focus {\n    outline: 1px solid var(--ids-color-border-focus);\n    outline-offset: -1px;\n    z-index: 5;\n  }\n\n  // Hide focus outline when interacting with mouse\n  &:focus.is-focused {\n    outline: none;\n  }\n\n  // Hide header cell outline when checkbox inside has focus\n  &:focus-within:has(.ids-data-grid-checkbox:focus) {\n    outline: none;\n  }\n\n  &.align-center .ids-data-grid-header-cell-content,\n  &.align-center .ids-data-grid-header-cell-filter-wrapper {\n    justify-content: center;\n  }\n\n  &.align-right .ids-data-grid-header-cell-content,\n  &.align-right .ids-data-grid-header-cell-filter-wrapper {\n    justify-content: flex-end;\n  }\n\n  &.align-right .is-sortable .ids-data-grid-header-text {\n    padding-inline-end: var(--ids-data-grid-padding-lg);\n    padding-inline-start: 5px;\n  }\n\n  &.align-right .ids-data-grid-header-cell-filter-wrapper {\n    ids-menu-button {\n      margin-inline-start: var(--ids-space-3xs);\n    }\n  }\n\n  // Resizing Cells\n  .resizer {\n    cursor: var(--ids-cursor-resize);\n    display: inline;\n    height: 100%;\n    position: absolute;\n    margin-inline-start: calc(100% - 4px);\n    top: var(--ids-space-none);\n    width: 6px;\n    z-index: 2;\n\n    .resize-indicator {\n      position: relative;\n      top: 21px;\n      inset-inline-end: 7px;\n      background-color: var(--ids-data-grid-header-resize-button-color);\n      border-radius: var(--ids-border-radius-sm);\n      box-shadow: var(--ids-box-shadow);\n      z-index: 1;\n\n      ids-icon:first-child {\n        transform: rotate(90deg);\n        inset-inline-start: 2px;\n      }\n\n    }\n\n    .resize-bar {\n      border-inline-start: 2px solid var(--ids-data-grid-header-resize-bar-color);\n      min-height: 500px;\n      position: absolute;\n      inset-inline-start: 50%;\n    }\n  }\n\n  // Reorderable Cells\n  .reorderer {\n    cursor: var(--ids-cursor-move);\n    display: inline;\n    height: 34px;\n    opacity: 0;\n    position: absolute;\n    inset-inline-start: 5px;\n    top: var(--ids-space-none);\n    width: var(--ids-space-2xs);\n\n    ids-icon {\n      position: absolute;\n      color: var(--ids-data-grid-header-color-icon);\n      inset-inline-start: calc(-1 * var(--ids-space-xs));\n      text-align: center;\n      top: calc(50% - 9px);\n    }\n  }\n\n  &.align-right .reorderer {\n    inset-inline-end: 3px;\n    inset-inline-start: initial;\n  }\n\n  &:last-child .resizer {\n    margin-inline-start: calc(100% - 6px); // Prevents unneeded scrollbar\n  }\n\n  &.dragging {\n    background-color: var(\n      --ids-data-grid-header-drag-background-color\n    ) !important; // this important is needed for drag styles to work\n\n    border-inline-start: var(--ids-space-none);\n    display: block;\n    left: -1000px;\n    position: absolute;\n    top: var(--ids-space-none);\n    width: 110px;\n  }\n\n  &.active-drag-column {\n    background-color: var(\n      --ids-data-grid-header-color-background-default-placeholder-dragging\n    );\n\n    .sort-indicator {\n      opacity: 0;\n    }\n  }\n\n  &:hover .reorderer {\n    opacity: 1;\n  }\n\n  // Reorderable Cells\n  &.frozen {\n    background-color: var(--ids-data-grid-header-color-background-default);\n    position: sticky;\n    z-index: 4;\n  }\n\n  // Change borders for frozen column scrolling\n  &.frozen-last {\n    border-inline-end: 1px solid var(--ids-data-grid-header-color-border);\n\n    + .ids-data-grid-header-cell {\n      border-inline-start-width: var(--ids-border-width-none);\n    }\n  }\n\n  &.frozen-left {\n    position: sticky;\n    left: var(--ids-space-none);\n    z-index: 2;\n\n    // Dynamically added widths\n    @for $i from 2 through 10 {\n      &:nth-of-type(#{$i}) {\n        left: var(--ids-data-grid-frozen-column-left-width-#{$i});\n      }\n    }\n  }\n\n  &.frozen-right {\n    position: sticky;\n    right: var(--ids-space-none);\n\n    // Wierd centering bug (frozen right)\n    .ids-data-grid-header-cell-content {\n      display: inline-flex;\n    }\n  }\n}\n\n// Column opacity for design mode\n.ids-data-grid-header-cell.has-opacity {\n  opacity: var(--ids-data-grid-header-cell-opacity, 0.2);\n  pointer-events: none;\n}\n\n.ids-data-grid-header-cell-content {\n  display: flex;\n}\n\n.ids-data-grid-header-text {\n  display: block;\n  padding: var(--ids-data-grid-header-lg-padding);\n  font-weight: var(--ids-font-weight-semibold);\n  font-size: var(--ids-data-grid-font-size-sm);\n  color: var(--ids-data-grid-header-color-text);\n  overflow: hidden;\n  text-align: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  small {\n    font-weight: var(--ids-font-weight-normal);\n    font-size: var(--ids-data-grid-font-size-sm);\n  }\n}\n\n.header-text-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// Required indicator using CSS pseudo-element\n.ids-data-grid-header-cell.is-required {\n  .header-text-content::after,\n  .ids-checkbox .label-text::after {\n    content: '*';\n    color: var(--ids-input-required-indicator-color-text-default);\n    margin-inline-start: var(--ids-space-3xs);\n  }\n}\n\n.ids-data-grid-header-icon {\n  align-self: center;\n  color: var(--ids-data-grid-header-color-text);\n  margin-inline-start: var(--ids-space-2xs);\n  margin-block-start: var(--ids-space-2xs);\n}\n\n// Header sort styles\n.sort-indicator {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: relative;\n  overflow: hidden;\n  height: calc(var(--ids-space-lg) - 2px);\n  width: 18px;\n}\n\n// Sort Hover states\n.is-sortable {\n  .sort-indicator ids-icon {\n    color: var(--ids-data-grid-header-color-icon-unsorted);\n    opacity: 0;\n    transition: opacity 0.3s var(--ids-motion-ease) 0s;\n\n    &:first-child {\n      position: relative;\n      top: var(--ids-space-2xs);\n      transform: rotate(180deg);\n    }\n\n    &:last-child {\n      position: relative;\n      top: -10px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    .sort-indicator ids-icon {\n      opacity: 1;\n    }\n  }\n}\n\n.header-expander {\n  display: none;\n  max-height: 18px;\n  cursor: var(--ids-cursor-pointer);\n  color: var(--ids-data-grid-header-expander-color);\n  margin-inline-start: var(--ids-space-12);\n\n  &:hover {\n    color: var(--ids-data-grid-header-expander-color-active);\n  }\n}\n\n[data-row-height='xxs'] .header-expander {\n  top: var(--ids-space-3xs);\n}\n\n:host([show-header-expander]) .header-expander,\n.column-header-expander .header-expander {\n  display: unset;\n}\n\n.has-selectioncheckbox .ids-data-grid-header-text:not(:focus-within) {\n  padding-inline-start: var(--ids-space-none);\n  padding-inline-end: var(--ids-space-none);\n}\n\n.is-sortable,\n.has-headericon {\n  .ids-data-grid-header-text {\n    padding-inline-end: var(--ids-space-none);\n  }\n}\n\n// Ascending sort\n[aria-sort='ascending'] .is-sortable .sort-indicator ids-icon {\n  &:first-child {\n    color: var(--ids-data-grid-header-color-icon-sorted);\n    opacity: 1;\n  }\n\n  &:last-child {\n    opacity: 1;\n  }\n}\n\n// Descending sort\n[aria-sort='descending'] .is-sortable .sort-indicator ids-icon {\n  &:first-child {\n    opacity: 1;\n  }\n\n  &:last-child {\n    color: var(--ids-data-grid-header-color-icon-sorted);\n    opacity: 1;\n  }\n}\n\n// Drag arrows for sorting\n.ids-data-grid-sort-arrows {\n  display: none;\n  height: 34px;\n  position: absolute;\n  z-index: 2;\n\n  &::before,\n  &::after {\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    content: '';\n    display: inline-block;\n    height: 0;\n    left: -5px;\n    position: absolute;\n    width: 0;\n  }\n\n  &::before {\n    border-top: 5px solid\n      var(--ids-data-grid-header-drag-arrow-color-background);\n    top: -6px;\n  }\n\n  &::after {\n    border-bottom: 5px solid\n      var(--ids-data-grid-header-drag-arrow-color-background);\n    bottom: -9px;\n  }\n}\n\n// Standalone Css\ntr.ids-data-grid-header {\n  display: table-row;\n  position: initial;\n}\n\nth.ids-data-grid-header-cell {\n  display: table-cell;\n}\n\n// List Style Feature\n.ids-data-grid.is-list-style {\n  // Change Header Color\n  .ids-data-grid-header-cell {\n    background-color: var(--ids-data-grid-list-header-color-background);\n    border-color: var(--ids-data-grid-list-header-color-border);\n  }\n\n  .ids-data-grid-header-text {\n    color: var(--ids-data-grid-list-header-color-text);\n  }\n\n  // Change Sort Icon Colors\n  .is-sortable {\n    ids-icon {\n      color: var(--ids-data-grid-header-color-icon-unsorted);\n    }\n  }\n\n  [aria-sort='descending'] .is-sortable ids-icon:last-child,\n  [aria-sort='ascending'] .is-sortable ids-icon:first-child {\n    color: var(--ids-data-grid-list-header-color-icon-unsorted);\n  }\n\n  // Change Header Checkbox\n  .ids-data-grid-header-text .ids-data-grid-checkbox-container {\n    .ids-data-grid-checkbox:not(.checked):not(.indeterminate) {\n      border-color: var(--ids-data-grid-list-header-checkbox-color-background);\n    }\n  }\n}\n\n// Used for Frozen Columns\n.ids-data-grid-body {\n  min-width: fit-content;\n}\n\n// Adjust for Row Heights (large is default)\n.ids-data-grid {\n  &[data-row-height='md'] {\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-md-padding);\n    }\n\n    .sort-indicator {\n      margin-inline-start: -8px;\n    }\n\n    .ids-data-grid-header-cell.align-right .reorderer {\n      inset-inline-end: 3px;\n    }\n\n    .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper)\n      .ids-data-grid-header-text {\n      padding-block-end: var(--ids-space-2xs);\n    }\n  }\n\n  &[data-row-height='sm'] {\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-sm-padding);\n    }\n\n    .reorderer {\n      display: none;\n    }\n\n    .sort-indicator {\n      margin-inline-start: -4px;\n    }\n\n    .ids-data-grid-header-cell:has(.ids-data-grid-header-cell-filter-wrapper) {\n      .ids-data-grid-header-text {\n        padding-block-end: var(--ids-space-2xs);\n      }\n\n      .ids-data-grid-header-cell-filter-wrapper {\n        padding-inline: var(--ids-space-xs);\n      }\n    }\n  }\n\n  &[data-row-height='xs'] {\n    .ids-data-grid-header {\n      height: 30px;\n\n      &.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {\n        height: 78px;\n      }\n\n      &.has-filter:has(.ids-data-grid-header-cell-filter-wrapper) {\n        height: 60px;\n      }\n    }\n\n    .ids-data-grid-header-cell {\n      min-height: 30px;\n\n      .has-filter &:has(.ids-data-grid-header-cell-filter-wrapper) {\n        height: 60px;\n      }\n    }\n\n    .has-filter\n      .ids-data-grid-header-cell:has(\n        .ids-data-grid-header-cell-filter-wrapper\n      ):has(br) {\n      height: 78px;\n    }\n\n    .has-filter .ids-data-grid-header-cell:has(\n        .ids-data-grid-header-cell-filter-wrapper\n      ):not(:has(br)) {\n      height: 60px;\n\n      .ids-data-grid-header-text {\n        padding-block-end: var(--ids-space-2xs);\n      }\n\n      .ids-data-grid-header-cell-filter-wrapper {\n        padding-inline: var(--ids-space-2xs);\n        padding-block-end: 6px;\n      }\n    }\n\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-xs-padding);\n    }\n\n    .reorderer {\n      display: none;\n    }\n\n    .sort-indicator {\n      margin-inline-start: -2px;\n      margin-inline-end: -2px;\n      margin-block-start: -3px;\n    }\n\n    .ids-data-grid-checkbox-container {\n      padding-top: var(--ids-space-3xs);\n    }\n\n    .ids-data-grid-header-cell.align-right\n      .is-sortable\n      .ids-data-grid-header-text {\n      padding-inline-end: var(--ids-data-grid-padding-xs);\n      padding-inline-start: 5px;\n    }\n  }\n\n  &[data-row-height='xxs'] {\n    .ids-data-grid-header {\n      height: 30px;\n\n      &:has(br) {\n        height: 62px;\n      }\n\n      &.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):has(br) {\n        height: 70px;\n      }\n\n      &.has-filter:has(.ids-data-grid-header-cell-filter-wrapper):not(:has(br)) {\n        height: 60px;\n      }\n    }\n\n    .ids-data-grid-header-cell {\n      min-height: 30px;\n\n      .has-filter &:has(.ids-data-grid-header-cell-filter-wrapper) {\n        height: 60px;\n      }\n    }\n\n    .has-filter\n      .ids-data-grid-header-cell:has(\n        .ids-data-grid-header-cell-filter-wrapper\n      ):has(br) {\n      height: 70px;\n    }\n\n    .has-filter .ids-data-grid-header-cell:has(\n        .ids-data-grid-header-cell-filter-wrapper\n      ):not(:has(br)) {\n      height: 60px;\n\n      .ids-data-grid-header-text {\n        padding: var(--ids-space-2xs);\n        padding-block-start: 6px;\n      }\n\n      .ids-data-grid-header-cell-filter-wrapper {\n        padding-inline: var(--ids-space-2xs);\n        padding-block-end: 6px;\n      }\n    }\n\n    .ids-data-grid-header-text {\n      padding: var(--ids-data-grid-header-xxs-padding);\n    }\n\n    .reorderer {\n      display: none;\n    }\n\n    .sort-indicator {\n      margin-inline-start: var(--ids-space-none);\n      margin-block-start: -1px;\n      height: 22px;\n\n      > ids-icon:first-child {\n        top: 3px;\n      }\n\n      ids-icon:last-child {\n        top: -11px;\n      }\n    }\n\n    .align-right .sort-indicator {\n      margin-inline-start: var(--ids-space-none);\n    }\n\n    .ids-data-grid-header-text .ids-data-grid-checkbox-container {\n      padding-top: 3px;\n    }\n\n    .ids-data-grid-header-cell.align-right\n      .is-sortable\n      .ids-data-grid-header-text {\n      padding-inline-end: 3px;\n      padding-inline-start: 3px;\n    }\n\n    // Filter Adjustments\n    ids-input,\n    ids-menu-button,\n    ids-trigger-field,\n    ids-dropdown {\n      --ids-input-height-10: 24px;\n    }\n\n    ids-dropdown {\n      --ids-input-font-size-sm: var(--ids-input-font-size-xs);\n    }\n\n    .ids-data-grid-header-cell-filter-wrapper {\n      padding-inline-start: calc(var(--ids-data-grid-padding-xxs) + 2px);\n      padding-inline-end: calc(var(--ids-data-grid-padding-xxs) + 2px);\n      padding-block-end: calc(var(--ids-data-grid-padding-xxs) - 1px);\n    }\n  }\n}\n\n// Column selection header\n.ids-data-grid .has-col-selection {\n  .ids-data-grid-header-cell:not([column-id='selectionCheckbox'])\n    .ids-data-grid-header-cell-content {\n    justify-content: flex-start;\n\n    .ids-data-grid-header-text .ids-checkbox .label-text {\n      position: absolute;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: 80%;\n    }\n\n    &.is-sortable,\n    &.is-reorderable {\n      .ids-data-grid-header-text .ids-checkbox .label-text {\n        width: 70%;\n      }\n    }\n\n    &.is-sortable.is-reorderable {\n      .ids-data-grid-header-text .ids-checkbox .label-text {\n        width: 60%;\n      }\n    }\n  }\n\n  .sort-indicator {\n    margin-inline-start: auto;\n  }\n}\n\n// Handle RTL\n:host([dir='rtl']) {\n  // Negate right alignment\n  .ids-data-grid-header-cell {\n    &.align-right .ids-data-grid-header-cell-content {\n      direction: ltr;\n    }\n\n    &:last-child {\n      border-inline-end-width: var(--ids-border-width-none);\n    }\n\n    &.frozen-left {\n      position: sticky;\n      right: var(--ids-space-none);\n\n      // Dynamically added widths\n      @for $i from 2 through 10 {\n        &:nth-of-type(#{$i}) {\n          right: var(--ids-data-grid-frozen-column-left-width-#{$i});\n        }\n      }\n    }\n  }\n}\n","/* Ids Data Grid Component - Rows */\n.ids-data-grid-row {\n  display: contents;\n  width: 100%;\n  height: inherit;\n\n  // When row contains textarea formatter, make all cells auto-height\n  &:has(.formatter-textarea) .ids-data-grid-cell {\n    height: auto;\n    min-height: var(--ids-data-grid-row-height-lg);\n    line-height: var(--ids-data-grid-line-height-lg);\n    align-items: center;\n  }\n\n  &.selected:not(.mixed) .ids-data-grid-cell,\n  &.activated .ids-data-grid-cell,\n  &.selected:not(.mixed):hover .ids-data-grid-cell {\n    background-color: var(--ids-data-grid-row-color-background-selected);\n    border-color: var(--ids-data-grid-cell-color-border-selected);\n\n    &:focus,\n    &.is-focused {\n      border-color: var(--ids-color-border-focus);\n    }\n  }\n\n  &.selected:not(.mixed) .ids-data-grid-cell.is-readonly:not(.exclude-readonly-style) {\n    background-color: var(--ids-data-grid-row-color-background-selected);\n  }\n\n  // Hidden Row\n  &[hidden] {\n    display: none;\n  }\n\n  // Row Status\n  &[part*='row-'] {\n    .ids-data-grid-cell:first-child::before {\n      border-style: solid;\n      border-width: 5px;\n      content: '';\n      position: absolute;\n      z-index: 1;\n      margin: 2px;\n      top: 0;\n    }\n  }\n\n  &[part='row-new'] {\n    .ids-data-grid-cell {\n      &:first-child::before {\n        border-color: var(--ids-data-grid-row-color-border-new) transparent transparent var(--ids-data-grid-row-color-border-new);\n      }\n\n      background-color: var(--ids-data-grid-row-color-background-new);\n      color: var(--ids-data-grid-cell-color-text-states-default);\n    }\n  }\n\n  &[part='row-removed'] {\n    .ids-data-grid-cell {\n      &:first-child::before {\n        border-color: var(--ids-data-grid-row-color-border-removed) transparent transparent var(--ids-data-grid-row-color-border-removed);\n      }\n\n      background-color: var(--ids-data-grid-row-color-background-removed);\n      color: var(--ids-data-grid-cell-color-text-states-default);\n    }\n  }\n\n  &[part='row-error'] {\n    .ids-data-grid-cell {\n      &:first-child::before {\n        border-color: var(--ids-data-grid-row-color-border-error) transparent transparent var(--ids-data-grid-row-color-border-error);\n      }\n\n      background-color: var(--ids-data-grid-row-color-background-error);\n      color: var(--ids-data-grid-cell-color-text-states-default);\n    }\n  }\n\n  &[part='row-warning'] {\n    .ids-data-grid-cell {\n      &:first-child::before {\n        border-color: var(--ids-data-grid-row-color-border-warning) transparent transparent var(--ids-data-grid-row-color-border-warning);\n      }\n\n      background-color: var(--ids-data-grid-row-color-background-warning);\n      color: var(--ids-data-grid-cell-color-text-states-default);\n    }\n  }\n\n  // Expandable Rows\n  &[aria-expanded='true'] .ids-data-grid-cell {\n    background-color: var(--ids-data-grid-expandable-areas-color-background-default);\n  }\n}\n\n// Grouped Rows\n.ids-data-grid-row.is-group-row {\n  .ids-data-grid-cell {\n    background-color: var(--ids-data-grid-row-grouped-color-background);\n    color: var(--ids-data-grid-row-grouped-color-text);\n    font-weight: var(--ids-data-grid-row-grouped-font-weight, 600);\n    border-inline-start: 0;\n    grid-column: 1 / -1;\n  }\n\n  ids-button {\n    --ids-button-tertiary-color-background-hover: transparent;\n    --ids-button-tertiary-color-border-hover: transparent;\n\n    padding: 0 2px;\n  }\n}\n\n// Row Height Feature with Formatters spacing\n.ids-data-grid {\n  // Large by default\n  &[data-row-height='md'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-md);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-md);\n        padding-inline-end: var(--ids-data-grid-padding-md);\n      }\n    }\n\n    .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {\n      min-height: var(--ids-data-grid-row-height-md);\n      line-height: var(--ids-data-grid-line-height-md);\n      height: auto;\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-md);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-md);\n    }\n  }\n\n  &[data-row-height='sm'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-sm);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-sm);\n        padding-inline-end: var(--ids-data-grid-padding-sm);\n      }\n    }\n\n    .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {\n      min-height: var(--ids-data-grid-row-height-sm);\n      height: auto;\n\n      .text-multiline {\n        padding: var(--ids-data-grid-padding-sm);\n        line-height: var(--ids-data-grid-line-height-sm);\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-sm);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-sm);\n    }\n  }\n\n  &[data-row-height='xs'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-xs);\n      font-size: var(--ids-data-grid-font-size-sm);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-xs);\n        padding-inline-end: var(--ids-data-grid-padding-xs);\n      }\n    }\n\n    .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {\n      min-height: var(--ids-data-grid-row-height-xs);\n      height: auto;\n\n      .text-multiline {\n        padding: var(--ids-data-grid-padding-xs);\n        line-height: var(--ids-data-grid-line-height-xs);\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xs);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xs);\n    }\n  }\n\n  &[data-row-height='xxs'] {\n    .ids-data-grid-cell {\n      height: var(--ids-data-grid-row-height-xxs);\n      font-size: var(--ids-data-grid-font-size-sm);\n\n      .text-ellipsis,\n      ids-badge {\n        padding-inline-start: var(--ids-data-grid-padding-xxs);\n        padding-inline-end: var(--ids-data-grid-padding-xxs);\n      }\n\n      // On 'xxs' row height, inline-editable cells have a slightly wider\n      // padding appearance to accommodate the inline display\n      &.is-inline {\n        .text-ellipsis {\n          padding-inline-start: var(--ids-data-grid-padding-xs);\n          padding-inline-end: var(--ids-data-grid-padding-xs);\n        }\n      }\n    }\n\n    .ids-data-grid-row:has(.formatter-textarea) .ids-data-grid-cell {\n      min-height: var(--ids-data-grid-row-height-xxs);\n      height: auto;\n\n      .text-multiline {\n        padding: var(--ids-data-grid-padding-xxs);\n        line-height: var(--ids-data-grid-line-height-xxs);\n      }\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell-content:not(.vertical-align-center) .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xxs);\n      transition: padding var(--ids-motion-duration) var(--ids-motion-ease);\n    }\n\n    .ids-data-grid-cell:not(.align-center) .ids-data-grid-header-cell:hover .ids-data-grid-header-cell-content:not(.vertical-align-center).is-reorderable .ids-data-grid-header-text {\n      padding-inline-start: var(--ids-data-grid-padding-xxs);\n    }\n  }\n\n  &.is-list-style .ids-data-grid-row.selected:not(.mixed) .ids-data-grid-cell {\n    border-inline-start-color: transparent;\n\n    &:focus {\n      border-inline-start-color: var(--ids-color-border-focus);\n    }\n  }\n}\n\n// Row Alternate Row Setting Feature\n.ids-data-grid.alt-row-shading ids-data-grid-row:nth-child(even)  ids-data-grid-cell {\n  background-color: var(--ids-data-grid-row-alternating-color-background);\n}\n\n// Expandable Row\n.ids-data-grid-expandable-row {\n  border-bottom: 1px solid var(--ids-data-grid-cell-color-border);\n  background-color: var(--ids-data-grid-expandable-areas-color-background-default);\n  grid-column: 1 / -1;\n  padding: var(--ids-space-xs);\n}\n\n// Standalone Css\ntr.ids-data-grid-row {\n  display: table-row;\n  height: var(--ids-data-grid-row-height-lg);\n}\n\n// Row Navigation Styles\n.ids-data-grid.row-navigation .ids-data-grid-body .ids-data-grid-row {\n  &:focus-within {\n     .ids-data-grid-cell {\n      border-block: 1px solid var(--ids-color-border-focus);\n\n      &:first-child {\n        border-inline-start: 1px solid var(--ids-color-border-focus);\n        position: relative;\n        z-index: 1;\n      }\n\n      &:last-child {\n        border-inline-end: 1px solid var(--ids-color-border-focus);\n      }\n    }\n  }\n\n  .ids-data-grid-cell:focus {\n    box-shadow: none;\n    outline: none;\n  }\n\n  // Fixes an issue where hyperlinks in row-navigation mode cannot be directly clicked\n  ids-hyperlink,\n  .ids-hyperlink {\n    transform: translateZ(1px);\n  }\n}\n\n:host([dir='rtl']) {\n  .ids-data-grid-row {\n    &[part='row-new'] {\n      .ids-data-grid-cell {\n        &:first-child::before {\n            border-color: var(--ids-data-grid-row-color-border-new) var(--ids-data-grid-row-color-border-new) transparent transparent;\n        }\n      }\n    }\n\n    &[part='row-removed'] {\n      .ids-data-grid-cell {\n        &:first-child::before {\n            border-color: var(--ids-data-grid-row-color-border-removed) var(--ids-data-grid-row-color-border-removed) transparent transparent;\n        }\n      }\n    }\n\n    &[part='row-warning'] {\n      .ids-data-grid-cell {\n        &:first-child::before {\n            border-color: var(--ids-data-grid-row-color-border-warning) var(--ids-data-grid-row-color-border-warning) transparent transparent;\n        }\n      }\n    }\n\n\n    &[part='row-error'] {\n      .ids-data-grid-cell {\n        &:first-child::before {\n            border-color: var(--ids-data-grid-row-color-border-error) var(--ids-data-grid-row-color-border-error) transparent transparent;\n        }\n      }\n    }\n  }\n}\n","/* Ids Data Grid Component - Cells */\n@use 'sass:list';\n\n/* Generates a pseudo-element representing the dirty tracker */\n@mixin ids-data-grid-cell-dirty-tracker-icon {\n  border-color: var(--ids-input-dirty-indicator-color-background-dirty)\n    transparent transparent\n    var(--ids-input-dirty-indicator-color-background-dirty);\n  border-style: solid;\n  border-width: 5px;\n  content: '';\n  display: inline-block;\n  margin-inline: var(--ids-space-3xs);\n  position: absolute;\n  inset-block-start: var(--ids-space-3xs);\n  z-index: 1;\n}\n\n/* Generates a pseudo-element representing the field indicator */\n@mixin ids-data-grid-cell-field-indicator-icon {\n  border-style: solid;\n  border-width: 5px;\n  content: '';\n  display: inline-block;\n  margin-inline: var(--ids-space-3xs);\n  position: absolute;\n  inset-block-start: var(--ids-space-3xs);\n  z-index: 1;\n}\n\nids-data-grid-cell[column-onscreen] {\n  visibility: visible;\n}\n\nids-data-grid-cell[column-offscreen] {\n  visibility: visible;\n}\n\nids-data-grid-cell[column-offscreen-left] {\n  visibility: visible;\n}\n\nids-data-grid-cell[column-offscreen-right] {\n  visibility: visible;\n}\n\n.ids-data-grid-row:not(.selected):not([part*='row-']) {\n  .ids-data-grid-cell:not(.is-readonly) {\n    &.frozen-left {\n      background-color: var(--ids-data-grid-color-background);\n    }\n\n    &.frozen-right {\n      background-color: var(--ids-data-grid-color-background);\n    }\n  }\n}\n\n.ids-data-grid-cell {\n  // Border and Background and Sizing\n  box-sizing: border-box;\n  align-items: center;\n  border-inline-start: 1px solid;\n  border-block-end: 1px solid;\n  border-color: var(--ids-data-grid-cell-color-border);\n  display: inline-flex;\n  color: var(--ids-data-grid-cell-color-text-default);\n  height: 50px;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n\n  // Hide first/last border\n  &:not([hidden]):not([skipped-cell]):first-child {\n    border-inline-start-width: var(--ids-border-width-none);\n  }\n\n  // Reset badge margin to center it vertically\n  ids-badge::part(badge) {\n    margin-block-end: var(--ids-space-none);\n    margin-inline-end: var(--ids-space-none);\n  }\n\n  ids-badge {\n    padding-inline-start: var(--ids-space-sm);\n    padding-inline-end: var(--ids-space-sm);\n  }\n\n  // So the color is the same as the editor\n  ids-icon[icon='dropdown'] {\n    color: var(--ids-trigger-field-icon-color);\n  }\n\n  ids-hyperlink {\n    margin: 0;\n    padding-inline: 12px;\n    height: 20px;\n    width: -moz-available;\n    width: -webkit-fill-available;\n    width: fill-available;\n  }\n\n  // Override width for hyperlinks in dropdown columns to allow clicking cell area\n  &.formatter-hyperlink.has-editor-dropdown {\n    ids-hyperlink {\n      width: auto;\n      display: inline-block;\n      max-width: 100%;\n    }\n  }\n\n  .text-ellipsis {\n    display: inline-block;\n    vertical-align: middle;\n    padding-inline-start: calc(var(--ids-space-xs) + 4px);\n    padding-inline-end: calc(var(--ids-space-xs) + 4px);\n    height: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .has-indicator {\n    display: flex;\n  }\n\n  .text-multiline {\n    display: inline-block;\n    vertical-align: middle;\n    padding: calc(var(--ids-space-xs) + 4px);\n    white-space: normal;\n  }\n\n  &.formatter-textarea {\n    height: auto;\n    min-height: var(--ids-data-grid-row-height-lg);\n    align-items: flex-start;\n    white-space: pre-line;\n    /* stylelint-disable-next-line property-no-deprecated */\n    word-wrap: break-word;\n  }\n\n  // Text Alignment\n  ids-icon {\n    vertical-align: middle;\n\n    + span {\n      vertical-align: middle;\n      line-height: 25px;\n      padding-inline: var(--ids-space-2xs);\n    }\n  }\n\n  // Row number indicator icon and spacer alignment\n  .row-number-indicator {\n    color: var(--ids-data-grid-row-indicator-color-icon);\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  .row-number-indicator-spacer {\n    display: inline-block;\n    width: 16px;\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  // Text Alignment\n  &.align-center {\n    & > *:first-child {\n      display: inline-flex;\n      margin: var(--ids-space-none) auto;\n    }\n  }\n\n  &.align-right {\n    & > *:first-child {\n      margin-inline-start: auto;\n      margin-inline-end: var(--ids-space-none);\n    }\n\n    ids-input {\n      text-align: right;\n    }\n  }\n\n  // Readonly and disabled Cells\n  &.is-readonly:not(.exclude-readonly-style):not(.selected) {\n    background-color: var(\n      --ids-data-grid-cell-color-background-frozen-readonly\n    );\n\n    .editor-cell-icon {\n      display: none;\n    }\n  }\n\n  &.is-disabled {\n    color: var(--ids-data-grid-cell-color-text-disabled);\n\n    .editor-cell-icon {\n      display: none;\n    }\n  }\n\n  &.is-uppercase {\n    text-transform: uppercase;\n  }\n\n  // Focus State\n  &:focus,\n  &.is-editing:not(.is-inline):focus-within,\n  &.is-focused {\n    &:not(.selected):not([tabindex='-1']) {\n      box-shadow: var(--ids-shadow-20);\n      outline: none;\n      border: 1px solid var(--ids-color-border-focus);\n      z-index: 1;\n\n      // Only frozen focused cells get elevated z-index so box-shadow\n      // is not clipped by adjacent frozen cells. Normal/readonly cells\n      // stay below frozen columns to avoid scroll overlap.\n      &.frozen {\n        z-index: 3;\n      }\n    }\n  }\n\n  &.formatter-textmask {\n    &.is-hoverable {\n      justify-content: space-between;\n\n      .text-ellipsis {\n        padding-inline-end: var(--ids-space-sm);\n      }\n    }\n\n    .editor-cell-icon {\n      margin-inline-end: 10px;\n      margin-block-start: var(--ids-space-3xs);\n      display: none;\n\n      &.show-cell-icon-always {\n        display: inline-flex;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    &:not(.is-inline):not(.is-invalid):hover,\n    &.is-editing {\n      .editor-cell-icon {\n        display: flex;\n      }\n\n      .text-ellipsis {\n        padding-inline-end: var(--ids-space-08);\n      }\n\n      ids-alert {\n        margin-inline: calc(100% - 48px);\n      }\n    }\n  }\n\n  &.is-editable {\n    &.is-readonly:not(.exclude-readonly-style) {\n      .text-ellipsis::after {\n        background-color: var(--ids-data-grid-cell-color-background-readonly);\n      }\n    }\n\n    &.is-inline {\n      &.formatter-tree {\n        .ids-data-grid-tree-container {\n          height: 100%;\n          width: 100%;\n        }\n\n        .ids-data-grid-tree-field-container {\n          height: 100%;\n          width: 100%;\n        }\n\n        .text-ellipsis {\n          align-items: center;\n          display: flex;\n          height: 100%;\n          justify-content: end;\n          width: 100%;\n        }\n\n        .text-ellipsis::after {\n          margin-inline-end: -8px;\n        }\n      }\n\n      ids-icon.editor-cell-icon {\n        display: inline-flex;\n        visibility: visible;\n        margin-inline-end: 15px;\n\n        &[icon='dropdown'] {\n          margin-inline-end: 12px;\n        }\n      }\n    }\n\n    &.is-lookup,\n    &.is-datepicker,\n    &.is-timepicker {\n      justify-content: space-between;\n\n      .text-ellipsis {\n        padding-inline-end: var(--ids-space-none);\n      }\n    }\n\n    &.is-datepicker,\n    &.is-timepicker {\n      ids-trigger-field {\n        margin-inline-start: -1px;\n        margin-block-start: 1px;\n      }\n    }\n\n    &.is-lookup {\n      ids-lookup {\n        border: 0;\n        outline: none;\n        width: 100%;\n      }\n\n      ids-lookup::part(container),\n      ids-lookup::part(field-container) {\n        background-color: var(--ids-color-transparent);\n        border: 0;\n        border-radius: 0;\n        box-shadow: none;\n        outline: none;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        margin: 0;\n      }\n    }\n\n    .editor-cell-icon {\n      margin-inline-end: 6px;\n      margin-block-start: var(--ids-space-3xs);\n      display: none;\n\n      &.show-cell-icon-always {\n        display: inline-flex;\n\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    }\n\n    ids-trigger-button::part(button) {\n      color: inherit;\n    }\n\n    // Show icon on hover\n    &:not(.is-inline):not(.is-invalid):not(.is-readonly):focus,\n    &:not(.is-inline):not(.is-invalid):not(.is-readonly):hover {\n      .editor-cell-icon {\n        display: flex;\n      }\n\n      ids-alert {\n        margin-inline: calc(100% - 48px);\n      }\n    }\n\n    &.is-editable.is-invalid {\n      justify-content: space-between;\n\n      &.formatter-hyperlink.has-editor-dropdown {\n        justify-content: end;\n      }\n\n      ids-alert {\n        margin-inline-end: 7px;\n      }\n    }\n  }\n\n  &.is-editing:not(.is-multiselect) ids-checkbox {\n    --ids-checkbox-margin-inline-end: 0;\n    --ids-checkbox-shadow-focus: 0 0 0 2px transparent, 0 0 0 3px transparent;\n    --ids-checkbox-color-border-focus: var(--ids-checkbox-border);\n\n    &[checked] {\n      --ids-checkbox-color-border-focus: var(\n        --ids-checkbox-color-background-selected\n      );\n    }\n\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    position: relative;\n    left: 6px;\n    top: 3px;\n  }\n\n  // Editing with popups\n  &.is-editing.is-lookup,\n  &.is-editing.is-datepicker,\n  &.is-editing.is-timepicker,\n  &.is-editing.is-password {\n    overflow: visible;\n  }\n\n  &.is-editing.is-inline ids-input {\n    z-index: 99;\n  }\n\n  // Dropdown Editable Cell\n  &.is-editable.is-dropdown {\n    .dropdown-cell-value {\n      width: 100%;\n    }\n\n    &.is-editing:not(.is-inline) {\n      border-inline-start-width: 0;\n    }\n  }\n\n  // Multiselect Editable Cell\n  &.is-editable.is-multiselect {\n    .multiselect-cell-value {\n      width: 100%;\n    }\n\n    &.is-editing:not(.is-inline) {\n      border-inline-start-width: 0;\n    }\n  }\n\n  // Dropdown Editing Inline\n  &.is-editing.is-dropdown.is-inline {\n    box-shadow: none;\n\n    ids-dropdown {\n      padding: 0 var(--ids-space-2xs);\n    }\n  }\n\n  // Text Editable Cell\n  &.formatter-text {\n    white-space: pre;\n  }\n\n  // Text Wrapping and Spacing\n  &.white-space-normal {\n    white-space: normal;\n  }\n\n  &.white-space-nowrap {\n    white-space: nowrap;\n  }\n\n  &.white-space-pre {\n    white-space: pre;\n  }\n\n  &.white-space-pre-line {\n    white-space: pre-line;\n  }\n\n  &.white-space-pre-wrap {\n    white-space: pre-wrap;\n  }\n\n  &.white-space-break-spaces {\n    white-space: break-spaces;\n  }\n\n  &[hidden] {\n    display: none;\n  }\n\n  &.formatter-row-reorder {\n    cursor: move;\n  }\n\n  // Editing Uppercase\n  &.is-editing.is-uppercase {\n    text-transform: uppercase;\n\n    ids-list-box-option,\n    ids-dropdown::part(triggerfield-input),\n    ids-input::part(input) {\n      text-transform: uppercase;\n    }\n  }\n\n  // Frozen Cells\n  &.frozen {\n    position: sticky;\n    background-color: var(--ids-data-grid-color-background);\n    z-index: 2; // below focused cell (z-index: 3) so focus box-shadow is not clipped\n  }\n\n  // Change borders for scrolling\n  &.frozen-last {\n    border-inline-end: 1px solid var(--ids-data-grid-cell-color-border);\n\n    + .ids-data-grid-cell {\n      border-inline-start: none;\n    }\n\n    + .ids-data-grid-cell[hidden] + .ids-data-grid-cell {\n      border-inline-start: none;\n    }\n  }\n\n  &.frozen-left {\n    position: sticky;\n    left: var(--ids-space-none);\n\n    // Dynamically added widths\n    @for $i from 2 through 10 {\n      &:nth-of-type(#{$i}) {\n        left: var(--ids-data-grid-frozen-column-left-width-#{$i});\n      }\n    }\n  }\n\n  &.frozen-right {\n    position: sticky;\n    right: var(--ids-space-none);\n  }\n\n  &.is-dirty::before {\n    @include ids-data-grid-cell-dirty-tracker-icon;\n  }\n\n  // Field indicator triangle and info icon\n  &.has-field-indicator::before {\n    @include ids-data-grid-cell-field-indicator-icon;\n  }\n\n  &.field-indicator-neutral::before {\n    border-color: var(--ids-color-accent-neutral-weak)\n      transparent transparent\n      var(--ids-color-accent-neutral-weak);\n  }\n\n  &.field-indicator-info::before {\n    border-color: var(--ids-color-info-default)\n      transparent transparent\n      var(--ids-color-info-default);\n  }\n\n  &.field-indicator-success::before {\n    border-color: var(--ids-color-success-default)\n      transparent transparent\n      var(--ids-color-success-default);\n  }\n\n  &.field-indicator-caution::before {\n    border-color: var(--ids-color-caution-default)\n      transparent transparent\n      var(--ids-color-caution-default);\n  }\n\n  &.field-indicator-warning::before {\n    border-color: var(--ids-color-warning-default)\n      transparent transparent\n      var(--ids-color-warning-default);\n  }\n\n  &.field-indicator-error::before {\n    border-color: var(--ids-color-error-default)\n      transparent transparent\n      var(--ids-color-error-default);\n  }\n\n  .cell-field-indicator-icon {\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    position: absolute;\n    inset-inline-end: var(--ids-space-xs);\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  // Field indicator icon colors matching the triangle\n  &.field-indicator-neutral .cell-field-indicator-icon {\n    color: var(--ids-color-accent-neutral-weak);\n  }\n\n  &.field-indicator-info .cell-field-indicator-icon {\n    color: var(--ids-color-info-default);\n  }\n\n  &.field-indicator-success .cell-field-indicator-icon {\n    color: var(--ids-color-success-default);\n  }\n\n  &.field-indicator-caution .cell-field-indicator-icon {\n    color: var(--ids-color-caution-default);\n  }\n\n  &.field-indicator-warning .cell-field-indicator-icon {\n    color: var(--ids-color-warning-default);\n  }\n\n  &.field-indicator-error .cell-field-indicator-icon {\n    color: var(--ids-color-error-default);\n  }\n\n  // Add padding to text when field indicator icon is present to prevent overlap\n  &.has-field-indicator {\n    .text-ellipsis {\n      padding-inline-end: calc(var(--ids-space-xs) + 20px);\n    }\n  }\n\n  // Hide the info icon when the cell is being edited\n  &.is-editing .cell-field-indicator-icon {\n    display: none;\n  }\n\n  &.is-dirty.is-inline {\n    &.formatter-tree {\n      &::before {\n        display: none;\n        content: none;\n      }\n\n      .ids-data-grid-tree-field-container {\n        position: relative;\n\n        &::before {\n          @include ids-data-grid-cell-dirty-tracker-icon;\n        }\n      }\n    }\n\n    &.is-dropdown::before {\n      margin-inline: 6px;\n      inset-block-start: 6px;\n    }\n\n    ids-input {\n      &::part(dirty-tracker-icon) {\n        --ids-icon-height-default: 12px !important;\n        --ids-icon-width-default: 12px !important;\n      }\n    }\n  }\n\n  &.is-dirty.is-dropdown.is-editing:not(.is-inline)::before {\n    inset-block-start: 3px;\n    margin-inline: 3px;\n  }\n\n  &.is-invalid {\n    background-color: var(--ids-data-grid-cell-color-background-error);\n\n    &.has-field-indicator {\n      ids-alert[icon=\"error\"] {\n        display: none;\n      }\n    }\n  }\n\n  &.selected {\n    background-color: var(--ids-data-grid-row-color-background-selected);\n  }\n\n  ids-alert {\n    margin-top: 3px;\n  }\n\n  ids-tag {\n    --ids-tag-margin-inline-end: 0;\n  }\n\n  ids-progress-bar {\n    margin: var(--ids-progress-bar-grid-cell-margin);\n  }\n\n  // Adjust trigger icon in edit mode\n  &.is-editing {\n    $icon-styles: (\n      'timepicker': 'clock',\n      'datepicker': 'calendar',\n    );\n\n    $field-heights: (\n      'xs': (\n        -3px,\n        1px,\n      ),\n      'sm': (\n        2px,\n        1px,\n      ),\n    );\n\n    @each $class, $icon in $icon-styles {\n      &.is-#{$class} {\n        @each $height, $values in $field-heights {\n          .ids-trigger-field-slot-trigger-end[icon='#{$icon}'][field-height='#{$height}'] {\n            margin-inline-end: list.nth($values, 1);\n            margin-block-start: list.nth($values, 2);\n          }\n        }\n      }\n    }\n  }\n}\n\n// =============================================\n// Row height: 'xxs'\n// =============================================\n[data-row-height='xxs'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-xxs);\n    }\n  }\n\n  .ids-data-grid-cell.is-dirty::before {\n    border-width: 4px;\n    inset-block-start: 1px;\n    inset-inline-start: -1px;\n  }\n\n  .ids-data-grid-cell.is-dirty.is-inline::before {\n    margin-inline: 3px;\n    top: 3px;\n  }\n\n  ids-button {\n    --ids-button-icon-padding: var(--ids-space-3xs);\n  }\n\n  ids-badge {\n    --ids-badge-font-line-height: calc(\n      var(--ids-data-grid-row-height-xxs) - 8px\n    );\n  }\n\n  ids-tag {\n    --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 6px);\n  }\n\n  ids-input,\n  ids-trigger-field {\n    --ids-space-3xs: 0;\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n  }\n\n  ids-input {\n    &::part(dirty-tracker-icon) {\n      --ids-icon-height-default: 10px !important;\n      --ids-icon-width-default: 10px !important;\n    }\n\n    &::part(input) {\n      height: calc(var(--ids-input-height-10));\n    }\n  }\n\n  .ids-data-grid-cell.is-editing {\n    ids-input::part(input) {\n      height: calc(var(--ids-input-height-10) - 4px);\n    }\n  }\n\n  // Adjust non inline editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: var(--ids-space-3xs);\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  }\n\n  .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {\n    padding: var(--ids-space-none) var(--ids-space-4xs);\n\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-xxs);\n    }\n\n    &.is-editable.is-editable.is-invalid ids-alert {\n      margin-inline-end: var(--ids-space-4xs);\n    }\n\n    ids-hyperlink {\n      padding-inline: var(--ids-space-2xs);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'xs'\n// =============================================\n\n[data-row-height='xs'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-xs);\n    }\n  }\n\n  .ids-data-grid-cell.is-dirty::before {\n    border-width: 4px;\n  }\n\n  .ids-data-grid-cell.is-dirty.is-inline::before {\n    margin-inline: 3px;\n    top: 3px;\n  }\n\n  ids-button {\n    --ids-button-icon-padding: 3px;\n  }\n\n  ids-badge {\n    --ids-badge-font-line-height: calc(\n      var(--ids-data-grid-row-height-xs) - 12px\n    );\n  }\n\n  ids-tag {\n    --ids-tag-height: calc(var(--ids-data-grid-row-height-xxs) - 4px);\n  }\n\n  ids-input {\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n\n    &::part(dirty-tracker-icon) {\n      --ids-icon-height-default: 12px !important;\n      --ids-icon-width-default: 12px !important;\n    }\n  }\n\n  // Adjust non inline editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: var(--ids-space-3xs);\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n    --ids-input-font-size-sm: var(--ids-data-grid-font-size-sm);\n  }\n\n  .ids-data-grid-cell.is-editing.is-dropdown.is-inline ids-dropdown {\n    padding: var(--ids-space-none) var(--ids-space-3xs);\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-xs);\n    }\n\n    ids-hyperlink {\n      padding-inline: var(--ids-space-2xs);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'sm'\n// =============================================\n\n[data-row-height='sm'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-sm);\n    }\n  }\n\n  ids-button {\n    --ids-button-icon-padding: var(--ids-space-2xs);\n  }\n\n  // Adjust non inline editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: 7px;\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: 5px;\n    margin-block-start: 0;\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-sm);\n    }\n\n    ids-hyperlink {\n      padding-inline: var(--ids-space-xs);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'md'\n// =============================================\n\n[data-row-height='md'] {\n  .formatter-progress {\n    ids-progress-bar {\n      margin: var(--ids-data-grid-padding-md);\n    }\n  }\n\n  // Adjust dropdown editor\n  .ids-data-grid-cell.is-editable .editor-cell-icon {\n    margin-inline-end: 6px;\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline ids-icon.editor-cell-icon {\n    margin-inline-end: var(--ids-data-grid-padding-sm);\n  }\n\n  .ids-data-grid-cell.is-editable.is-inline {\n    --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n\n    ::slotted(ids-trigger-button) {\n      position: relative;\n      top: 100px;\n    }\n  }\n\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-md);\n    }\n  }\n}\n\n// =============================================\n// Row height: 'lg'\n// =============================================\n\n[data-row-height='lg'] {\n  .ids-data-grid-cell {\n    .ids-data-grid-checkbox-container:not(.is-selection-checkbox) {\n      padding-inline: var(--ids-data-grid-padding-lg);\n    }\n  }\n}\n\n// List Style Feature\n.ids-data-grid.is-list-style {\n  // Change Cell Borders/BG\n  .ids-data-grid-cell {\n    border-inline-start: 1px solid transparent;\n    border-bottom: 1px solid var(--ids-data-grid-list-cell-color-border);\n\n    &.is-readonly:not(.exclude-readonly-style) {\n      background-color: var(--ids-data-grid-cell-color-background-readonly);\n    }\n\n    &.is-disabled {\n      color: var(--ids-data-grid-cell-color-text-disabled);\n    }\n\n    &:not([hidden]):not([skipped-cell]):first-child {\n      border-inline-start-width: 1px;\n    }\n  }\n\n  .ids-data-grid-body .ids-data-grid-row:first-child .ids-data-grid-cell:not(:focus):not(.is-focused):not(.is-editing) {\n    border-top: 0;\n  }\n}\n\n// Standalone Css\ntd.ids-data-grid-cell {\n  display: table-cell;\n  padding-inline-start: var(--ids-space-sm);\n  padding-inline-end: var(--ids-space-sm);\n}\n\n// Handle RTL\n:host([dir='rtl']) {\n  .ids-data-grid.is-list-style {\n    .ids-data-grid-cell {\n      border-inline-end-width: var(--ids-border-width-none);\n    }\n  }\n\n  // Negate Borders\n  .ids-data-grid-cell {\n    &.frozen-left {\n      position: sticky;\n      right: var(--ids-space-none);\n\n      // Dynamically added widths\n      @for $i from 2 through 10 {\n        &:nth-of-type(#{$i}) {\n          right: var(--ids-data-grid-frozen-column-left-width-#{$i});\n        }\n      }\n    }\n\n    &:last-child {\n      border-inline-end-width: var(--ids-border-width-none);\n    }\n\n    &.is-dirty {\n      .ids-data-grid-tree-field-container::before,\n      &::before {\n        border-color: var(--ids-input-dirty-indicator-color-background-dirty)\n          var(--ids-input-dirty-indicator-color-background-dirty) transparent\n          transparent;\n      }\n    }\n\n    &.field-indicator-neutral::before {\n      border-color: var(--ids-color-accent-neutral-weak)\n        var(--ids-color-accent-neutral-weak) transparent\n        transparent;\n    }\n\n    &.field-indicator-info::before {\n      border-color: var(--ids-color-info-default)\n        var(--ids-color-info-default) transparent\n        transparent;\n    }\n\n    &.field-indicator-success::before {\n      border-color: var(--ids-color-success-default)\n        var(--ids-color-success-default) transparent\n        transparent;\n    }\n\n    &.field-indicator-caution::before {\n      border-color: var(--ids-color-caution-default)\n        var(--ids-color-caution-default) transparent\n        transparent;\n    }\n\n    &.field-indicator-warning::before {\n      border-color: var(--ids-color-warning-default)\n        var(--ids-color-warning-default) transparent\n        transparent;\n    }\n\n    &.field-indicator-error::before {\n      border-color: var(--ids-color-error-default)\n        var(--ids-color-error-default) transparent\n        transparent;\n    }\n\n    &.formatter-textmask {\n      .is-textmask {\n        unicode-bidi: plaintext;\n      }\n    }\n  }\n}\n\n// Fix slotted trigger button margins when nested within cells\n.ids-trigger-field-slot-trigger-end {\n  margin-inline-end: 2px;\n  margin-block-start: 1px;\n}\n","/* stylelint-disable no-invalid-position-declaration */\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Includes Hidden Classes and Mixins for hiding elements at breakpoints\n.hide {\n  display: none;\n}\n\n.hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n.hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin breakpoint-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    @content;\n  }\n}\n","@use '../../themes/mixins/ids-hide-mixin.scss' as hide;\n\n:host(.hide-sm-down) {\n  @include hide.hide-sm-down();\n}\n\n.ids-popup-menu {\n  &:not([hidden]) {\n    display: block;\n    z-index: var(--ids-z-index-160);\n  }\n}\n","/**\n * Checkbox Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin checkbox-unchecked() {\n  position: absolute;\n  border: var(--ids-checkbox-border);\n  border-radius: var(--ids-checkbox-border-radius);\n  height: 14px;\n  width: 14px;\n  left: 0;\n  top: 3px;\n}\n\n@mixin checkbox-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-error);\n}\n\n// Checked\n@mixin checkbox-checked() {\n  background-color: var(--ids-checkbox-color-background-selected);\n  border-color: var(--ids-checkbox-color-border-selected);\n}\n\n@mixin checkbox-checked-after {\n  position: absolute;\n  display: block;\n  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);\n  border-width: var(--ids-checkbox-border-width-selected-after);\n  animation: check 0.15s ease-out;\n  transform: rotate(45deg);\n  content: '';\n  height: 10px;\n  left: 4px;\n  top: 0;\n  width: 4px;\n}\n\n// Indeterminate\n@mixin checkbox-indeterminate() {\n  background-color: var(--ids-checkbox-color-background-indeterminate);\n  border-color: var(--ids-checkbox-color-border-indeterminate);\n}\n\n@mixin checkbox-indeterminate-after {\n  position: absolute;\n  animation: checkindeterminate 0.15s ease-out;\n  display: block;\n  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);\n  border-width: var(--ids-checkbox-border-width-indeterminate);\n  content: '';\n  height: 6px;\n  left: 2px;\n  top: 0;\n  transform: none;\n  width: 10px;\n}\n\n// Disabled\n@mixin checkbox-disabled-unchecked {\n  background-color: var(--ids-checkbox-color-background-disabled);\n  border-color: var(--ids-checkbox-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n}\n\n@mixin checkbox-disabled-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n}\n\n@mixin checkbox-disabled-checked() {\n  background-color: var(--ids-checkbox-color-background-selected-disabled);\n  border-color: var(--ids-checkbox-color-border-selected-disabled);\n}\n\n@mixin checkbox-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-checkbox-color-text-disabled);\n}\n\n// Focus\n@mixin checkbox-focus {\n  border-color: var(--ids-checkbox-color-border-focus);\n  box-shadow: var(--ids-checkbox-shadow-focus);\n}\n\n@mixin checkbox-focus-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n  box-shadow: var(--ids-checkbox-shadow-focus-error);\n}\n\n// Colored\n$color-names: 'green' 'purple' 'blue' 'orange' 'red';\n$color-vars: --ids-color-green-70 --ids-color-purple-70 --ids-color-blue-70 --ids-color-orange-70 --ids-color-red-70;\n\n@mixin checkbox-colored() {\n  @each $name in $color-names {\n    $i: list.index($color-names, $name);\n    $color: var(#{list.nth($color-vars, $i)});\n\n    &[color='#{$name}'] input[type='checkbox'] {\n      ~ .checkmark {\n        @include checkbox-colored-box($color);\n      }\n\n      &:disabled ~ .checkmark {\n        @include checkbox-disabled-unchecked();\n      }\n\n      &:disabled:checked ~ .checkmark {\n        @include checkbox-disabled-checked();\n      }\n\n      &:focus ~ .checkmark {\n        @include checkbox-colored-box-focus($color);\n      }\n    }\n  }\n}\n\n@mixin checkbox-colored-box($color) {\n  background-color: $color;\n  border-color: $color;\n}\n\n@mixin checkbox-colored-box-focus($color) {\n  border-color: $color;\n}\n\n// Animations\n@keyframes check {\n  0% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 0;\n  }\n\n  50% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 4px;\n  }\n\n  100% {\n    height: 10px;\n    left: 4px;\n    top: 0;\n    width: 4px;\n  }\n}\n\n@keyframes checkindeterminate {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 10px;\n  }\n}\n","/**\n * Radio Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin radio-unchecked {\n  position: absolute;\n  border: 1px solid var(--ids-radio-color-border-default);\n  border-radius: var(--ids-radio-border-radius);\n  height: 14px;\n  left: 0;\n  top: 2px;\n  transition: all var(--ids-motion-duration) var(--ids-motion-ease);\n  width: 14px;\n}\n\n@mixin radio-unchecked-after {\n  position: absolute;\n  background-color: var(--ids-radio-color-background);\n  border: 1px solid var(--ids-radio-color-background);\n  border-radius: var(--ids-radio-border-radius);\n  content: '';\n  height: 0;\n  left: 6px;\n  top: 6px;\n  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), all var(--ids-motion-duration) var(--ids-motion-ease);\n  width: 0;\n  transform: scale(0);\n}\n\n@mixin radio-unchecked-error-circle {\n  border-color: var(--ids-color-error-default);\n}\n\n@mixin radio-unchecked-error-label-text {\n  color: var(--ids-color-error-default);\n}\n\n// Checked\n@mixin radio-checked {\n  background-color: var(--ids-radio-color-background-selected);\n  border-color: var(--ids-radio-color-border-selected);\n}\n\n@mixin radio-checked-after {\n  background-color: var(--ids-radio-inner-color-background-selected);\n  border-color: var(--ids-radio-inner-color-background-selected);\n  border-width: 2px;\n  height: 4px;\n  left: 3px;\n  top: 3px;\n  width: 4px;\n  transform: scale(1);\n}\n\n// Disabled\n@mixin radio-disabled-unchecked {\n  border-color: var(--ids-radio-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n  box-shadow: none;\n  opacity: var(--ids-radio-disabled-opacity);\n}\n\n@mixin radio-disabled-unchecked-error-circle {\n  border-color: var(--ids-radio-color-border-disabled);\n}\n\n@mixin radio-disabled-unchecked-error-label-text {\n  color: var(--ids-radio-color-border-disabled);\n}\n\n@mixin radio-disabled-checked() {\n  background-color: var(--ids-radio-color-background-selected-disabled);\n  border-color: var(--ids-radio-color-border-selected-disabled);\n  opacity: var(--ids-radio-disabled-opacity);\n}\n\n@mixin radio-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-radio-color-text-disabled);\n  opacity: var(--ids-radio-disabled-opacity);\n}\n\n// Focus\n@mixin radio-focus {\n  box-shadow: var(--ids-radio-shadow);\n}\n\n@mixin radio-focus-not-hide-focus {\n  box-shadow: var(--ids-radio-shadow-focus);\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// ================================================\n// Generates a pseudo-element in the form of an \"outline\"\n// in a cell that represents the \"inline, editable\" state.\n@mixin ids-data-grid-inline-editable-outline($margin) {\n  position: relative;\n\n  &::after {\n    border: 1px solid var(--ids-input-color-border-default);\n    border-radius: var(--ids-border-radius-2xs);\n    box-sizing: border-box;\n    display: block;\n    content: '';\n    margin: #{$margin}px;\n    height: calc(100% - #{$margin * 2}px);\n    position: absolute;\n    width: calc(100% - #{$margin * 2}px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
